<template>
  <div class="fullheight" style="width: 100%">
    <eco-table
      @load="loadData"
      :data="data"
      :pageResult="pageResult"
      :selection="true"
      :show-export="false"
      :quick-search-props="[
        { prop: 'mapped_name', label: '被映射对象名称' },
        { prop: 'mapped_no', label: '编码' },
        { prop: 'mapping_name', label: '映射对象名称' },
        { prop: 'mapping_no', label: '编码' }
      ]"
      ref="ecoTable"
    >
      <template v-slot:toolbar>
        <el-dropdown class="toolbarItem" v-if="tax_no != 'k3' && tenantId != ''">
          <el-button size="small">映射类型配置 <i class="el-icon-arrow-down el-icon--right"></i></el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item size="small" @click.native="showAcctTypeDialog('Project')">项目组映射配置 </el-dropdown-item>
            <el-dropdown-item size="small" @click.native="showAcctTypeDialog('Basics')">基础资料组映射配置 </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-dropdown class="toolbarItem">
          <el-button size="small">批量配置 <i class="el-icon-arrow-down el-icon--right"></i></el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item size="small" @click.native="showImport('CostAccount', 18)">营销费用科目</el-dropdown-item>
            <el-dropdown-item size="small" @click.native="showImport('CostAccount', 1)">OA费用科目 </el-dropdown-item>
            <el-dropdown-item size="small" @click.native="showImport('CostAccount', 2)">设计费用科目 </el-dropdown-item>
            <el-dropdown-item size="small" @click.native="showImport('CostAccount', 3)">施工费用科目 </el-dropdown-item>
            <el-dropdown-item size="small" @click.native="showImport('Org')">部门关系 </el-dropdown-item>
            <el-dropdown-item size="small" @click.native="showImport('User')">员工关系 </el-dropdown-item>
            <el-dropdown-item size="small" @click.native="showImport('Supplier')">供应商关系 </el-dropdown-item>
            <el-dropdown-item size="small" @click.native="showImport('Customer')">客户关系 </el-dropdown-item>
            <el-dropdown-item size="small" @click.native="showImport('DesignPro')">设计项目 </el-dropdown-item>
            <el-dropdown-item size="small" @click.native="showImport('ConPro')">施工项目 </el-dropdown-item>
            <el-dropdown-item size="small" @click.native="showImport('MarketPro')">营销项目 </el-dropdown-item>
            <el-dropdown-item v-if="tax_no === 'k3'" size="small" @click.native="showImport('CostAccount', -5)">设计费用科目映射(营销)</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>

        <el-dropdown class="toolbarItem">
          <el-button size="small">映射配置 <i class="el-icon-arrow-down el-icon--right"></i></el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item size="small" @click.native="ShowExpenseAccount()">费用科目</el-dropdown-item>
            <el-dropdown-item size="small" @click.native="showDialogBank()">银行账号 </el-dropdown-item>
            <el-dropdown-item size="small" @click.native="showPayType()">付款方式</el-dropdown-item>
            <el-dropdown-item size="small" @click.native="showPayMentType()">收款方式 </el-dropdown-item>
            <!--                <el-dropdown-item size="small" @click.native="showInvoiceType()" >发票类型</el-dropdown-item>-->
            <el-dropdown-item size="small" @click.native="showGroup()">部门关系</el-dropdown-item>
            <el-dropdown-item size="small" @click.native="showUser()">员工关系</el-dropdown-item>
            <el-dropdown-item size="small" @click.native="showSupplier()">供应商关系</el-dropdown-item>
            <el-dropdown-item size="small" @click.native="showCustomer()">客户关系</el-dropdown-item>
            <el-dropdown-item size="small" @click.native="showProjectDesign()">设计项目</el-dropdown-item>
            <el-dropdown-item size="small" @click.native="showProject()">施工项目</el-dropdown-item>
            <el-dropdown-item size="small" @click.native="showProjectMarketing()">营销项目</el-dropdown-item>
            <el-dropdown-item size="small" @click.native="showAdministrative()">行政费用报销科目</el-dropdown-item>
            <el-dropdown-item size="small" @click.native="showInvoiceShineupon()">发票税率映射</el-dropdown-item>
            <el-dropdown-item size="small" @click.native="showFrjgztDialog()" v-if="checkTaxno()">法人机构账套映射</el-dropdown-item>
            <el-dropdown-item size="small" @click.native="showInvoiceShineDown()" v-if="checkTaxno('k3')">发票不含税税率映射</el-dropdown-item>
            <el-dropdown-item size="small" @click.native="showContract(null, '22')" v-if="checkTaxno('k3')">材料采购合同类型映射</el-dropdown-item>
            <el-dropdown-item size="small" @click.native="showContract(null, '23')" v-if="checkTaxno('k3')">专业分包合同类型映射</el-dropdown-item>
            <el-dropdown-item size="small" @click.native="showContract(null, '24')" v-if="checkTaxno('k3')">劳务分包合同类型映射</el-dropdown-item>
            <el-dropdown-item size="small" @click.native="showContract(null, '25')" v-if="checkTaxno('k3')">租赁分包合同类型映射</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>

        <el-dropdown class="toolbarItem" v-if="tax_no === 'k3'">
          <el-button size="small">参数配置 <i class="el-icon-arrow-down el-icon--right"></i></el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item size="small" @click.native="showParamsSet()">设计前期项目是否映射科目</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>

        <fe-delete-button class="toolbarItem" url="${third}/third_financial_mapping/" :htTable="$refs.ecoTable">删除</fe-delete-button>
      </template>
      <template>
        <eco-table-column type="index" width="50" align="center" label="序号" />
        <eco-table-column prop="financial_type" label="财务系统类型" :filters="financialTypeArray">
          <template v-slot="{ row }">
            <el-tag v-show="row.financial_type == s.value" :type="s.type" v-for="s in financialTypeArray" :key="s.value">{{ s.text }} </el-tag>
          </template>
        </eco-table-column>
        <eco-table-column prop="mapping_type" label="映射类型" :show-overflow-tooltip="true" :filters="mappingTypeArray">
          <template v-slot="{ row }">
            <el-tag v-show="row.mapping_type == s.value" :type="s.type" v-for="s in mappingTypeArray" :key="s.value">{{ s.text }} </el-tag>
          </template>
        </eco-table-column>
        <eco-table-column prop="mapped_name" label="被映射对象名称" :sortable="true" />
        <eco-table-column prop="mapped_no" label="被映射对象编码" :sortable="true" />
        <eco-table-column prop="mapping_name" label="映射对象名称" :sortable="true" />
        <eco-table-column prop="mapping_no" label="映射对象编码" :sortable="true" />
        <eco-table-column width="150" label="操作">
          <template v-slot="{ row }">
            <el-link
              type="primary"
              :underline="false"
              v-if="!['15', '13', '11', '-1', '-2', '-3', '-4', '-5'].includes(row.mapping_type)"
              @click="handleCommand({ row: row, command: 'edit' })"
              >编辑
            </el-link>
          </template>
        </eco-table-column>
      </template>
    </eco-table>

    <el-dialog :close-on-click-modal="false" width="60%" :visible="dialogVisible" :before-close="handleClose" append-to-body v-loading="loadData">
      <div slot="title" class="dialog-header-title">
        <span class="name">费用科目映射</span>
      </div>
      <div class="content">
        <el-form :model="model" :rules="rules" ref="editModelForm" data-vv-scope="editModelForm" label-width="200px">
          <el-row style="height: 4rem" v-if="checkTaxno()">
            <el-form-item prop="corporate_id" label="法人机构" label-width="200px">
              <el-select v-model="model.corporate_name" placeholder="请输入法人机构" clearable filterable @change="(params) => setFRJGCode(params, 2)">
                <el-option v-for="item in frjgDicData" :key="item.company_name" :label="item.company_name" :value="item.company_name"> </el-option>
              </el-select>
            </el-form-item>
          </el-row>
          <el-row style="height: 4rem">
            <el-col :span="12">
              <el-form-item prop="mapped_name" label="费用科目名称" label-width="200px">
                <el-select v-model="model.mapped_name" placeholder="请输入费用科目名称" clearable filterable @change="setFykmCode">
                  <el-option v-for="item in fykmDicData" :key="item.key" :label="item.name" :value="item.key"> </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="费用科目编码" label-width="200px">
                <el-input v-model="model.mapped_no" autocomplete="off" placeholder="请输入费用科目编码" disabled></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row style="height: 4rem" v-show="showOaMapping">
            <el-col :span="12">
              <el-form-item prop="oa_mapping_name" label="会计科目名称（OA）" label-width="200px">
                <el-select v-model="model.oa_mapping_name" placeholder="请输入会计科目名称" clearable filterable @change="setNcOaCode">
                  <el-option v-for="item in ncAccountData" :key="item.id" :label="item.name" :value="item.id"> </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="会计科目代码（OA）" label-width="200px">
                <el-input v-model="model.oa_mapping_no" autocomplete="off" placeholder="请输入会计科目代码" disabled></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row style="height: 4rem" v-show="showDesignMapping">
            <el-col :span="12">
              <el-form-item label="会计科目名称（设计）" label-width="200px">
                <el-select v-model="model.design_mapping_name" placeholder="请输入会计科目名称" clearable filterable @change="setNcDesignCode">
                  <el-option v-for="item in ncAccountData" :key="item.id" :label="item.name" :value="item.id"> </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="会计科目代码（设计）" label-width="200px">
                <el-input v-model="model.design_mapping_no" autocomplete="off" placeholder="请输入会计科目代码" disabled></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row style="height: 4rem" v-show="showConstructionMapping">
            <el-col :span="12">
              <el-form-item label="会计科目名称（施工）" label-width="200px">
                <el-select v-model="model.construction_mapping_name" placeholder="请输入会计科目名称" clearable filterable @change="setNcConstructionCode">
                  <el-option v-for="item in ncAccountData" :key="item.id" :label="item.name" :value="item.id"> </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="会计科目代码（施工）" label-width="200px">
                <el-input v-model="model.construction_mapping_no" autocomplete="off" placeholder="请输入会计科目代码" disabled></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row style="height: 4rem" v-show="showMarketingMapping">
            <el-col :span="12">
              <el-form-item label="会计科目名称（营销）" label-width="200px">
                <el-select v-model="model.market_mapping_name" placeholder="请输入会计科目名称" clearable filterable @change="setNcMarketingCode">
                  <el-option v-for="item in ncAccountData" :key="item.id" :label="item.name" :value="item.id"> </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="会计科目代码（营销）" label-width="200px">
                <el-input v-model="model.market_mapping_no" autocomplete="off" placeholder="请输入会计科目代码" disabled></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row style="height: 4rem">
            <el-col :span="12">
              <el-form-item label="编制人" label-width="200px">
                <el-input v-model="model.create_by_name_" autocomplete="off" :validate="{ required: true }" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="编制时间" label-width="200px">
                <el-input
                  class="el-input-date"
                  prefix-icon="el-icon-date"
                  v-model="model.createTime"
                  placeholder="选择日期"
                  format="yyyy-MM-dd HH:mm:SS"
                  disabled
                >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submiteditModelFormData('editModelForm', accountUrl, requestMethod)">保存 </el-button>
        <el-button @click="handleClose('editGroupForm')">{{ $t('eip.common.cancel') }}</el-button>
      </div>
    </el-dialog>

    <el-dialog :close-on-click-modal="false" width="60%" :visible="dialogVisibleBank" :before-close="handleClose" append-to-body v-loading="loadData">
      <div slot="title" class="dialog-header-title">
        <span class="name">银行账号与会计科目映射</span>
      </div>
      <div class="content">
        <el-form :model="model" :rules="rules" ref="editBankForm" data-vv-scope="editBankForm">
          <el-row style="height: 4rem">
            <el-col :span="12">
              <el-form-item prop="mapped_name" label="开户行" label-width="200px">
                <el-select v-model="model.mapped_name" placeholder="请输入开户行" clearable filterable @change="setBankCode">
                  <el-option v-for="item in bankDicData" :key="item.key" :label="item.name" :value="item.key"> </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="账号" label-width="200px">
                <el-input
                  v-model="model.mapped_no"
                  autocomplete="off"
                  :validate="{ required: true }"
                  placeholder="请输入账号"
                  readonly="readonly"
                  disabled="disabled"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row style="height: 4rem">
            <el-col :span="12">
              <el-form-item prop="mapping_name" label="会计科目名称" label-width="200px">
                <el-select v-model="model.mapping_name" placeholder="请输入会计科目名称" clearable filterable @change="setNCcode">
                  <el-option v-for="item in ncAccountData" :key="item.id" :label="item.name" :value="item.id"> </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="会计科目代码" label-width="200px">
                <el-input v-model="model.mapping_no" autocomplete="off" placeholder="请输入会计科目代码" disabled="disabled"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row style="height: 4rem">
            <el-col :span="12">
              <el-form-item label="编制人" label-width="200px">
                <el-input v-model="model.create_by_name_" autocomplete="off" :validate="{ required: true }" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="编制时间" label-width="200px">
                <el-input
                  class="el-input-date"
                  prefix-icon="el-icon-date"
                  v-model="model.createTime"
                  placeholder="选择日期"
                  format="yyyy-MM-dd HH:mm:SS"
                  disabled
                >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitData('editBankForm', 'third_financial_mapping/saveBankMapping')">保存 </el-button>
        <el-button @click="handleClose('editGroupForm')">{{ $t('eip.common.cancel') }}</el-button>
      </div>
    </el-dialog>

    <el-dialog :close-on-click-modal="false" width="60%" :visible="payTypeVisible" :before-close="handleClose" append-to-body v-loading="loadData">
      <div slot="title" class="dialog-header-title">
        <span class="name">付款方式与会计科目映射</span>
      </div>
      <div class="content">
        <el-form :model="model" :rules="rules" ref="editPayTypeForm" data-vv-scope="editPayTypeForm">
          <el-row style="height: 4rem">
            <el-col :span="12">
              <el-form-item label="付款方式" label-width="200px">
                <el-select v-model="model.mapped_name" placeholder="请输入付款方式" clearable filterable @change="setFykmCode">
                  <el-option v-for="item in fykmDicData" :key="item.key" :label="item.name" :value="item.key"> </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="付款方式key" label-width="200px">
                <el-input v-model="model.mapped_no" autocomplete="off" :validate="{ required: true }" placeholder="付款方式key" disabled></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row style="height: 4rem">
            <el-col :span="12">
              <el-form-item prop="mapping_name" label="会计科目科目名称" label-width="200px">
                <el-select v-model="model.mapping_name" placeholder="请输入会计科目名称" clearable filterable @change="setNCcode">
                  <el-option v-for="item in ncAccountData" :key="item.id" :label="item.name" :value="item.id"> </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="会计科目代码" label-width="200px">
                <el-input v-model="model.mapping_no" autocomplete="off" placeholder="会计科目代码" disabled="disabled"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row style="height: 4rem">
            <el-col :span="12">
              <el-form-item label="编制人" label-width="200px">
                <el-input v-model="model.create_by_name_" autocomplete="off" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="编制时间" label-width="200px">
                <el-input
                  class="el-input-date"
                  prefix-icon="el-icon-date"
                  v-model="model.createTime"
                  placeholder="选择日期"
                  format="yyyy-MM-dd HH:mm:SS"
                  disabled
                >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitData('editPayTypeForm', 'third_financial_mapping/fpdTypeCostAccountMapping')">保存 </el-button>
        <el-button @click="handleClose('editGroupForm')">{{ $t('eip.common.cancel') }}</el-button>
      </div>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" width="60%" :visible="paymentTypeVisible" :before-close="handleClose" append-to-body v-loading="loadData">
      <div slot="title" class="dialog-header-title">
        <span class="name">付款方式与会计科目映射</span>
      </div>
      <div class="content">
        <el-form :model="model" :rules="rules" ref="editPayTypeForm" data-vv-scope="editPayTypeForm">
          <el-row style="height: 4rem">
            <el-col :span="12">
              <el-form-item label="付款方式" label-width="200px">
                <el-select v-model="model.mapped_name" placeholder="请输入付款方式" clearable filterable @change="setFykmCode">
                  <el-option v-for="item in fykmDicData" :key="item.key" :label="item.name" :value="item.key"> </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="付款方式key" label-width="200px">
                <el-input v-model="model.mapped_no" autocomplete="off" :validate="{ required: true }" placeholder="付款方式key" disabled></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row style="height: 4rem">
            <el-col :span="12">
              <el-form-item prop="mapping_name" label="会计科目科目名称" label-width="200px">
                <el-select v-model="model.mapping_name" placeholder="请输入会计科目名称" clearable filterable @change="setNCcode">
                  <el-option v-for="item in ncAccountData" :key="item.id" :label="item.name" :value="item.id"> </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="会计科目代码" label-width="200px">
                <el-input v-model="model.mapping_no" autocomplete="off" placeholder="会计科目代码" disabled="disabled"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row style="height: 4rem">
            <el-col :span="12">
              <el-form-item label="编制人" label-width="200px">
                <el-input v-model="model.create_by_name_" autocomplete="off" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="编制时间" label-width="200px">
                <el-input
                  class="el-input-date"
                  prefix-icon="el-icon-date"
                  v-model="model.createTime"
                  placeholder="选择日期"
                  format="yyyy-MM-dd HH:mm:SS"
                  disabled
                >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitData('editPayTypeForm', 'third_financial_mapping/fpdTypeCostAccountMapping')">保存</el-button>
        <el-button @click="handleClose('editGroupForm')">{{ $t('eip.common.cancel') }}</el-button>
      </div>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" width="60%" :visible="paymentTypeVisible" :before-close="handleClose" append-to-body v-loading="loadData">
      <div slot="title" class="dialog-header-title">
        <span class="name">收款方式与会计科目映射</span>
      </div>
      <div class="content">
        <el-form :model="model" :rules="rules" ref="editPayMentTypeForm" data-vv-scope="editPayMentTypeForm">
          <el-row style="height: 4rem">
            <el-col :span="12">
              <el-form-item prop="mapped_name" label="收款方式" label-width="200px">
                <el-select v-model="model.mapped_name" placeholder="请输入收款方式" clearable filterable @change="setCwskfsCode">
                  <el-option v-for="item in fykmDicData" :key="item.key" :label="item.name" :value="item.key"> </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="收款方式key" label-width="200px">
                <el-input v-model="model.mapped_no" autocomplete="off" placeholder="收款方式key" disabled></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row style="height: 4rem">
            <el-col :span="12">
              <el-form-item prop="mapping_name" label="会计科目科目名称" label-width="200px">
                <el-select v-model="model.mapping_name" placeholder="请输入会计科目名称" clearable filterable @change="setPayMentCode">
                  <el-option v-for="item in ncAccountData" :key="item.id" :label="item.name_show" :value="item.id"> </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="会计科目代码" label-width="200px">
                <el-input v-model="model.mapping_no" autocomplete="off" placeholder="会计科目代码" readonly="readonly" disabled></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row style="height: 4rem">
            <el-col :span="12">
              <el-form-item label="编制人" label-width="200px">
                <el-input v-model="model.create_by_name_" autocomplete="off" :validate="{ required: true }" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="编制时间" label-width="200px">
                <el-input
                  class="el-input-date"
                  prefix-icon="el-icon-date"
                  v-model="model.createTime"
                  placeholder="选择日期"
                  format="yyyy-MM-dd HH:mm:SS"
                  disabled
                >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="submitData('editPayMentTypeForm', 'third_financial_mapping/fcdTypeCostAccountMapping')">保存 </el-button>
          <el-button @click="handleClose('editPayMentTypeForm')">{{ $t('eip.common.cancel') }}</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" width="60%" :visible="invoiceVisible" :before-close="handleClose" append-to-body v-loading="loadData">
      <div slot="title" class="dialog-header-title">
        <span class="name">进项发票类型可抵扣映射</span>
      </div>
      <div class="content">
        <el-form v-model="model" data-vv-scope="editInvoiceForm">
          <div>
            <table class="form-table" cellspacing="0" cellpadding="0" border="0">
              <tbody>
                <tr>
                  <th>进项发票类型</th>
                  <th>是否可抵扣</th>
                </tr>
                <tr v-for="item in model.mappingList">
                  <td>
                    {{ item.mapped_name }}
                  </td>
                  <td>
                    <div>
                      <el-switch v-model="item.is_deductible" active-text="可抵扣" active-value="1" inactive-value="0" inactive-text="不可抵扣"> </el-switch>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <el-row style="height: 4rem"> </el-row>
          <el-row style="height: 4rem">
            <el-col :span="12">
              <el-form-item label="编制人" label-width="200px">
                <el-input v-model="model.create_by_name_" autocomplete="off" :validate="{ required: false }" readonly="readonly" disabled="disabled"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="编制时间" label-width="200px">
                <el-input
                  class="el-input-date"
                  prefix-icon="el-icon-date"
                  v-model="model.createTime"
                  placeholder="选择日期"
                  format="yyyy-MM-dd HH:mm:SS"
                  disabled
                >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <fe-submit-button
          url="/third_financial_mapping/saveInvoiceTypeMapping"
          context="third"
          :model="model"
          scope-name="editInvoiceForm"
          @after-save-data="afterSaveData"
          >{{ $t('eip.common.save') }}
        </fe-submit-button>
        <el-button @click="handleClose()">{{ $t('eip.common.cancel') }}</el-button>
      </div>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" width="60%" :visible="invoiceVisible" :before-close="handleClose" append-to-body v-loading="loadData">
      <div slot="title" class="dialog-header-title">
        <span class="name">进项发票类型可抵扣映射</span>
      </div>
      <div class="content">
        <el-form v-model="model" data-vv-scope="editInvoiceForm">
          <div>
            <table class="form-table" cellspacing="0" cellpadding="0" border="0">
              <tbody>
                <tr>
                  <th>进项发票类型</th>
                  <th>是否可抵扣</th>
                </tr>
                <tr v-for="item in model.mappingList">
                  <td>
                    {{ item.mapped_name }}
                  </td>
                  <td>
                    <div>
                      <el-switch v-model="item.is_deductible" active-text="可抵扣" active-value="1" inactive-value="0" inactive-text="不可抵扣"> </el-switch>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <el-row style="height: 4rem"> </el-row>
          <el-row style="height: 4rem">
            <el-col :span="12">
              <el-form-item label="编制人" label-width="200px">
                <el-input v-model="model.create_by_name_" autocomplete="off" :validate="{ required: false }" readonly="readonly" disabled="disabled"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="编制时间" label-width="200px">
                <el-input
                  class="el-input-date"
                  prefix-icon="el-icon-date"
                  v-model="model.createTime"
                  placeholder="选择日期"
                  format="yyyy-MM-dd HH:mm:SS"
                  disabled
                >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <fe-submit-button
          url="/third_financial_mapping/saveInvoiceTypeMapping"
          context="third"
          :model="model"
          scope-name="editInvoiceForm"
          @after-save-data="afterSaveData"
          >{{ $t('eip.common.save') }}</fe-submit-button
        >
        <el-button @click="handleClose()">{{ $t('eip.common.cancel') }}</el-button>
      </div>
    </el-dialog>

    <el-dialog :close-on-click-modal="false" width="60%" :visible="dialogVisibleGroup" :before-close="handleClose" append-to-body v-loading="loadData">
      <div slot="title" class="dialog-header-title">
        <span class="name">部门关系管理</span>
      </div>
      <div class="content">
        <el-form :model="model" :rules="rules" ref="editGroupForm" data-vv-scope="editGroupForm">
          <el-row style="height: 4rem">
            <el-col :span="12">
              <el-form-item label="系统部门名称" prop="mapped_name" label-width="200px">
                <el-input
                  class="input-with-select"
                  v-model="model.mapped_name"
                  prefix-icon="el-icon-search"
                  autocomplete="off"
                  ref="inputSelector"
                  placeholder="请选择系统部门"
                  clearable
                  @focus="showOrgDialog()"
                >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="系统部门编码" label-width="200px">
                <el-input v-model="model.mapped_no" autocomplete="off" placeholder="请输入系统部门编码" readonly="readonly" disabled="disabled"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row style="height: 4rem">
            <el-col :span="12">
              <el-form-item prop="mapped_name_show" label="财务部门" label-width="200px">
                <el-select v-model="model.mapped_name_show" placeholder="请输入财务部门/编码" clearable filterable @change="setDeptCode">
                  <el-option v-for="item in orgList" :key="item.id" :label="item.name_show" :value="item.id"> </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="财务部门编码" label-width="200px">
                <el-input
                  v-model="model.mapping_no"
                  autocomplete="off"
                  :validate="{ required: true }"
                  placeholder="请输入财务部门编码"
                  disabled="disabled"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row style="height: 4rem">
            <el-col :span="12">
              <el-form-item label="编制人" label-width="200px">
                <el-input v-model="model.create_by_name_" autocomplete="off" :validate="{ required: true }" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="编制时间" label-width="200px">
                <el-input
                  class="el-input-date"
                  prefix-icon="el-icon-date"
                  v-model="model.createTime"
                  placeholder="选择日期"
                  format="yyyy-MM-dd HH:mm:SS"
                  disabled
                >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitData('editGroupForm', 'third_financial_mapping/saveDepartmentMapping')">保存 </el-button>
        <el-button @click="handleClose('editGroupForm')">{{ $t('eip.common.cancel') }} </el-button>
      </div>
    </el-dialog>

    <el-dialog :close-on-click-modal="false" width="60%" :visible="dialogVisibleUser" :before-close="handleClose" append-to-body v-loading="loadData">
      <div slot="title" class="dialog-header-title">
        <span class="name">员工映射</span>
      </div>
      <div class="content">
        <el-form :model="model" :rules="rules" data-vv-scope="editUserForm" ref="editUserForm">
          <el-row style="height: 4rem">
            <el-col :span="12">
              <el-form-item prop="mapped_name" label="系统员工姓名" label-width="200px">
                <el-input
                  class="input-with-select"
                  v-model="model.mapped_name"
                  clearable
                  prefix-icon="el-icon-search"
                  autocomplete="off"
                  ref="inputSelector"
                  :validate="{ required: true }"
                  placeholder="请选择系统员工"
                  @focus="showUserDialog()"
                >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="系统员工工号" label-width="200px">
                <el-input v-model="model.mapped_no" autocomplete="off" placeholder="请输入系统部门编码" disabled></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row style="height: 4rem">
            <el-col :span="12">
              <el-form-item prop="mapped_name_show" label="财务职员" label-width="200px">
                <el-select v-model="model.mapped_name_show" placeholder="请输入职员名称/编码" clearable filterable @change="setUserCode">
                  <el-option v-for="item in userList" :key="item.id" :label="item.name_show" :value="item.id"> </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="财务职员编码" label-width="200px">
                <el-input v-model="model.mapping_no" autocomplete="off" placeholder="请输入财务职员编码" disabled="disabled"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row style="height: 4rem">
            <el-col :span="12">
              <el-form-item label="编制人" label-width="200px">
                <el-input v-model="model.create_by_name_" autocomplete="off" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="编制时间" label-width="200px">
                <el-input
                  class="el-input-date"
                  prefix-icon="el-icon-date"
                  v-model="model.createTime"
                  placeholder="选择日期"
                  format="yyyy-MM-dd HH:mm:SS"
                  disabled
                >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitData('editUserForm', 'third_financial_mapping/saveEmployeeMapping')">保存 </el-button>
        <el-button @click="handleClose('editUserForm')">{{ $t('eip.common.cancel') }} </el-button>
      </div>
      <eip-user-dialog ref="eipUserDialog" @onConfirm="addUnderUser" append-to-body :user-type="1" :single="true" />
    </el-dialog>

    <el-dialog :close-on-click-modal="false" width="60%" :visible="dialogVisibleSupplier" :before-close="handleClose" append-to-body v-loading="loadData">
      <div slot="title" class="dialog-header-title">
        <span class="name">供应商映射</span>
      </div>
      <div class="content">
        <el-form :model="model" :rules="rules" ref="editSupplierForm" data-vv-scope="editSupplierForm">
          <el-row style="height: 4rem">
            <el-col :span="12">
              <el-form-item prop="mapped_name" label="供应商名称" label-width="200px">
                <el-input
                  class="input-with-select"
                  prefix-icon="el-icon-search"
                  v-model="model.mapped_name"
                  autocomplete="off"
                  ref="inputSelector"
                  clearable
                  :validate="{ required: true }"
                  placeholder="请选择系统商名称"
                  @focus="showSupplierDialog()"
                >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="供应商编码" label-width="200px">
                <el-input v-model="model.mapped_no" autocomplete="off" :validate="{ required: true }" placeholder="请输入供应商编码" disabled></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row style="height: 4rem">
            <el-col :span="12">
              <el-form-item label="财务供应商" prop="mapped_name_show" label-width="200px">
                <el-select v-model="model.mapped_name_show" placeholder="请输入供应商名称/客户编码" clearable filterable @change="setSupplerCode">
                  <el-option v-for="item in supplerList" :key="item.id" :label="item.name_show" :value="item.id"> </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="财务供应商编码" label-width="200px">
                <el-input
                  v-model="model.mapping_no"
                  autocomplete="off"
                  :validate="{ required: true }"
                  placeholder="请输入供应商编码"
                  disabled="disabled"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row style="height: 4rem">
            <el-col :span="12">
              <el-form-item label="编制人" label-width="200px">
                <el-input v-model="model.create_by_name_" autocomplete="off" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="编制时间" label-width="200px">
                <el-input
                  class="el-input-date"
                  prefix-icon="el-icon-date"
                  v-model="model.createTime"
                  placeholder="选择日期"
                  format="yyyy-MM-dd HH:mm:SS"
                  disabled
                >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitData('editSupplierForm', 'third_financial_mapping/saveSupplierMapping')">保存 </el-button>
        <el-button @click="handleClose('editSupplierForm')">{{ $t('eip.common.cancel') }}</el-button>
      </div>
      <evo-supplier-dialog ref="evoSupplierDialog" @onConfirm="addSupplier" append-to-body :user-type="1" :customerSort="'2'" :single="true" />
    </el-dialog>
    <el-dialog :close-on-click-modal="false" width="60%" :visible="dialogVisibleSupplier" :before-close="handleClose" append-to-body v-loading="loadData">
      <div slot="title" class="dialog-header-title">
        <span class="name">供应商映射</span>
      </div>
      <div class="content">
        <el-form :model="model" :rules="rules" ref="editSupplierForm" data-vv-scope="editSupplierForm">
          <el-row style="height: 4rem">
            <el-col :span="12">
              <el-form-item prop="mapped_name" label="供应商名称" label-width="200px">
                <el-input
                  class="input-with-select"
                  prefix-icon="el-icon-search"
                  v-model="model.mapped_name"
                  autocomplete="off"
                  ref="inputSelector"
                  clearable
                  :validate="{ required: true }"
                  placeholder="请选择系统商名称"
                  @focus="showSupplierDialog()"
                >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="供应商编码" label-width="200px">
                <el-input v-model="model.mapped_no" autocomplete="off" :validate="{ required: true }" placeholder="请输入供应商编码" disabled></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row style="height: 4rem">
            <el-col :span="12">
              <el-form-item label="财务供应商" prop="mapped_name_show" label-width="200px">
                <el-select v-model="model.mapped_name_show" placeholder="请输入供应商名称/客户编码" clearable filterable @change="setSupplerCode">
                  <el-option v-for="item in supplerList" :key="item.id" :label="item.name_show" :value="item.id"> </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="财务供应商编码" label-width="200px">
                <el-input
                  v-model="model.mapping_no"
                  autocomplete="off"
                  :validate="{ required: true }"
                  placeholder="请输入供应商编码"
                  disabled="disabled"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row style="height: 4rem">
            <el-col :span="12">
              <el-form-item label="编制人" label-width="200px">
                <el-input v-model="model.create_by_name_" autocomplete="off" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="编制时间" label-width="200px">
                <el-input
                  class="el-input-date"
                  prefix-icon="el-icon-date"
                  v-model="model.createTime"
                  placeholder="选择日期"
                  format="yyyy-MM-dd HH:mm:SS"
                  disabled
                >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitData('editSupplierForm', 'third_financial_mapping/saveSupplierMapping')">保存</el-button>
        <el-button @click="handleClose('editSupplierForm')">{{ $t('eip.common.cancel') }}</el-button>
      </div>
      <evo-supplier-dialog ref="evoSupplierDialog" @onConfirm="addSupplier" append-to-body :user-type="1" :customerSort="'2'" :single="true" />
    </el-dialog>

    <el-dialog :close-on-click-modal="false" width="60%" :visible="dialogVisibleCustomer" :before-close="handleClose" append-to-body v-loading="loadData">
      <div slot="title" class="dialog-header-title">
        <span class="name">客户映射</span>
      </div>
      <div class="content">
        <el-form :model="model" :rules="rules" ref="editCustomerForm" data-vv-scope="editCustomerForm">
          <el-row style="height: 4rem">
            <el-col :span="12">
              <el-form-item label="客户名称" prop="mapped_name" label-width="200px">
                <el-input
                  class="input-with-select"
                  prefix-icon="el-icon-search"
                  v-model="model.mapped_name"
                  autocomplete="off"
                  clearable
                  ref="inputSelector"
                  :validate="{ required: true }"
                  placeholder="请选择系统客户"
                  @focus="showCustomerDialog()"
                >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="客户编码" label-width="200px">
                <el-input
                  v-model="model.mapped_no"
                  autocomplete="off"
                  :validate="{ required: true }"
                  placeholder="请输入客户编码"
                  readonly="readonly"
                  disabled="disabled"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row style="height: 4rem">
            <el-col :span="12">
              <el-form-item prop="mapped_name_show" label="财务客户名称" label-width="200px">
                <el-select v-model="model.mapped_name_show" placeholder="请输入客户名称/客户编码" clearable filterable @change="setCustomerCode">
                  <el-option v-for="item in custpmerList" :key="item.id" :label="item.name_show" :value="item.id"> </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="财务客户编码" label-width="200px">
                <el-input v-model="model.mapping_no" autocomplete="off" placeholder="请输入客户编码" disabled="disabled"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row style="height: 4rem">
            <el-col :span="12">
              <el-form-item label="编制人" label-width="200px">
                <el-input v-model="model.create_by_name_" autocomplete="off" :validate="{ required: true }" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="编制时间" label-width="200px">
                <el-input
                  class="el-input-date"
                  prefix-icon="el-icon-date"
                  v-model="model.createTime"
                  placeholder="选择日期"
                  format="yyyy-MM-dd HH:mm:SS"
                  disabled
                >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitData('editCustomerForm', 'third_financial_mapping/saveCustomerMapping')">保存 </el-button>
        <el-button @click="handleClose('editCustomerForm')">{{ $t('eip.common.cancel') }}</el-button>
      </div>
      <evo-customer-dialog ref="evoCustomerDialog" @onConfirm="addSupplier" append-to-body :user-type="1" :customerSort="'1'" :single="true" />
    </el-dialog>
    <el-dialog :close-on-click-modal="false" width="60%" :visible="dialogVisibleCustomer" :before-close="handleClose" append-to-body v-loading="loadData">
      <div slot="title" class="dialog-header-title">
        <span class="name">客户映射</span>
      </div>
      <div class="content">
        <el-form :model="model" :rules="rules" ref="editCustomerForm" data-vv-scope="editCustomerForm">
          <el-row style="height: 4rem">
            <el-col :span="12">
              <el-form-item label="客户名称" prop="mapped_name" label-width="200px">
                <el-input
                  class="input-with-select"
                  prefix-icon="el-icon-search"
                  v-model="model.mapped_name"
                  autocomplete="off"
                  clearable
                  ref="inputSelector"
                  :validate="{ required: true }"
                  placeholder="请选择系统客户"
                  @focus="showCustomerDialog()"
                >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="客户编码" label-width="200px">
                <el-input
                  v-model="model.mapped_no"
                  autocomplete="off"
                  :validate="{ required: true }"
                  placeholder="请输入客户编码"
                  readonly="readonly"
                  disabled="disabled"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row style="height: 4rem">
            <el-col :span="12">
              <el-form-item prop="mapped_name_show" label="财务客户名称" label-width="200px">
                <el-select v-model="model.mapped_name_show" placeholder="请输入客户名称/客户编码" clearable filterable @change="setCustomerCode">
                  <el-option v-for="item in custpmerList" :key="item.id" :label="item.name_show" :value="item.id"> </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="财务客户编码" label-width="200px">
                <el-input v-model="model.mapping_no" autocomplete="off" placeholder="请输入客户编码" disabled="disabled"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row style="height: 4rem">
            <el-col :span="12">
              <el-form-item label="编制人" label-width="200px">
                <el-input v-model="model.create_by_name_" autocomplete="off" :validate="{ required: true }" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="编制时间" label-width="200px">
                <el-input
                  class="el-input-date"
                  prefix-icon="el-icon-date"
                  v-model="model.createTime"
                  placeholder="选择日期"
                  format="yyyy-MM-dd HH:mm:SS"
                  disabled
                >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitData('editCustomerForm', 'third_financial_mapping/saveCustomerMapping')">保存</el-button>
        <el-button @click="handleClose('editCustomerForm')">{{ $t('eip.common.cancel') }}</el-button>
      </div>
      <evo-customer-dialog ref="evoCustomerDialog" @onConfirm="addSupplier" append-to-body :user-type="1" :customerSort="'1'" :single="true" />
    </el-dialog>

    <el-dialog :close-on-click-modal="false" width="60%" :visible="dialogProjectType" :before-close="handleClose" append-to-body v-loading="loadData">
      <div slot="title" class="dialog-header-title">
        <span class="name">项目类型与财务映射</span>
      </div>
      <div class="content">
        <el-form :model="model" :rules="rules" ref="editProjectTypeForm" data-vv-scope="editProjectTypeForm">
          <el-row style="height: 4rem">
            <el-col :span="12">
              <el-form-item prop="mapped_name_show" label="项目类型" label-width="200px">
                <el-select v-model="model.mapped_name_show" placeholder="请输入项目类型" clearable filterable @change="setProjectType">
                  <el-option v-for="item in projectTypes" :key="item.desc" :label="item.name_show" :value="item.desc"> </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row style="height: 4rem">
            <el-col :span="12">
              <el-form-item prop="mapping_name_show" label="财务核算项目分组名称" label-width="200px">
                <el-select v-model="model.mapping_name_show" placeholder="请输入财务核算项目分组" clearable filterable @change="setProjectGroupTypes">
                  <el-option v-for="item in projectGroups" :key="item.id" :label="item.name_show" :value="item.id"> </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="财务核算项目分组编码" label-width="200px">
                <el-input
                  v-model="model.mapping_no"
                  autocomplete="off"
                  :validate="{ required: true }"
                  placeholder="请输入财务核算项目分组编码"
                  readonly="readonly"
                  disabled="disabled"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row style="height: 4rem">
            <el-col :span="12">
              <el-form-item label="编制人" label-width="200px">
                <el-input v-model="model.create_by_name_" autocomplete="off" :validate="{ required: true }" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="编制时间" label-width="200px">
                <el-input
                  class="el-input-date"
                  prefix-icon="el-icon-date"
                  v-model="model.createTime"
                  placeholder="选择日期"
                  format="yyyy-MM-dd HH:mm:SS"
                  disabled
                >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitData('editProjectTypeForm', 'third_financial_mapping/saveProjectGroupMapping')">保存 </el-button>
        <el-button @click="handleClose('editCustomerForm')">{{ $t('eip.common.cancel') }}</el-button>
      </div>
    </el-dialog>

    <el-dialog :close-on-click-modal="false" width="60%" :visible="showDesignProject" :before-close="handleClose" append-to-body v-loading="loadData">
      <div slot="title" class="dialog-header-title">
        <span class="name">设计项目与财务映射</span>
      </div>
      <div class="content">
        <el-form :model="model" :rules="rules" ref="editDesignProjectForm" data-vv-scope="editDesignProjectForm">
          <el-row style="height: 4rem">
            <el-col :span="12">
              <el-form-item prop="mapped_name" label="设计项目名称" label-width="200px">
                <el-input
                  class="input-with-select"
                  prefix-icon="el-icon-search"
                  v-model="model.mapped_name"
                  autocomplete="off"
                  clearable
                  ref="inputSelector"
                  placeholder="请选择设计项目"
                  @focus="showDesignDialog()"
                >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="设计项目编码" label-width="200px">
                <el-input v-model="model.mapped_no" autocomplete="off" placeholder="请输入设计项目编码" readonly="readonly" disabled="disabled"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row style="height: 4rem">
            <el-col :span="12">
              <el-form-item prop="mapped_name_show" label="财务核算项目名称" label-width="200px">
                <el-select v-model="model.mapped_name_show" placeholder="请输入项目名称/编码" clearable filterable @change="setProjectGroups">
                  <el-option v-for="item in selectList" :key="item.id" :label="item.name_show" :value="item.id"> </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="财务核算项目编码" label-width="200px">
                <el-input v-model="model.mapping_no" autocomplete="off" placeholder="请输入财务核算项目编码" disabled=""></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row style="height: 4rem">
            <el-col :span="12">
              <el-form-item label="编制人" label-width="200px">
                <el-input v-model="model.create_by_name_" autocomplete="off" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="编制时间" label-width="200px">
                <el-input
                  class="el-input-date"
                  prefix-icon="el-icon-date"
                  v-model="model.createTime"
                  placeholder="选择日期"
                  format="yyyy-MM-dd HH:mm:SS"
                  disabled
                >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitData('editDesignProjectForm', 'third_financial_mapping/saveDesignProjectMapping')">保存 </el-button>
        <el-button @click="handleClose('editDesignProjectForm')">{{ $t('eip.common.cancel') }} </el-button>
      </div>
      <evo-design-dialog ref="evoDesignDialog" @onConfirm="addDesignPro" append-to-body :single="true" />
    </el-dialog>

    <el-dialog :close-on-click-modal="false" width="60%" :visible="showConProject" :before-close="handleClose" append-to-body v-loading="loadData">
      <div slot="title" class="dialog-header-title">
        <span class="name">施工与财务映射</span>
      </div>
      <div class="content">
        <el-form :model="model" :rules="rules" ref="editConProjectForm" data-vv-scope="editConProjectForm">
          <el-row style="height: 4rem">
            <el-col :span="12">
              <el-form-item prop="mapped_name" label="施工项目名称" label-width="200px">
                <el-input
                  prefix-icon="el-icon-search"
                  v-model="model.mapped_name"
                  autocomplete="off"
                  ref="inputSelector"
                  placeholder="请选择施工项目"
                  readonly="readonly"
                  @focus="showConstructionProDialog()"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="项目编码" label-width="200px">
                <el-input
                  v-model="model.mapped_no"
                  autocomplete="off"
                  :validate="{ required: true }"
                  placeholder="请输入项目编码"
                  readonly="readonly"
                  disabled="disabled"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row style="height: 4rem">
            <el-col :span="12">
              <el-form-item prop="mapped_name_show" label="财务核算项目名称" label-width="200px">
                <el-select v-model="model.mapped_name_show" placeholder="请输入项目名称/编码" clearable filterable @change="setProjectGroups">
                  <el-option v-for="item in selectList" :key="item.id" :label="item.name_show" :value="item.id"> </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="财务核算项目编码" label-width="200px">
                <el-input v-model="model.mapping_no" autocomplete="off" placeholder="请输入财务核算项目编码" disabled=""></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row style="height: 4rem">
            <el-col :span="12">
              <el-form-item label="编制人" label-width="200px">
                <el-input v-model="model.create_by_name_" autocomplete="off" :validate="{ required: true }" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="编制时间" label-width="200px">
                <el-input
                  class="el-input-date"
                  prefix-icon="el-icon-date"
                  v-model="model.createTime"
                  placeholder="选择日期"
                  format="yyyy-MM-dd HH:mm:SS"
                  disabled
                >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitData('editConProjectForm', 'third_financial_mapping/saveConProjectMapping')">保存 </el-button>
        <el-button @click="handleClose('editConProjectForm')">{{ $t('eip.common.cancel') }} </el-button>
      </div>
      <evo-project-dialog ref="evoProjectDialog" @onConfirm="addConstructionPro" append-to-body :single="true" />
    </el-dialog>

    <el-dialog :close-on-click-modal="false" width="60%" :visible="showMarketingProject" :before-close="handleClose" append-to-body v-loading="loadData">
      <div slot="title" class="dialog-header-title">
        <span class="name">营销项目与财务映射</span>
      </div>
      <div class="content">
        <el-form :model="model" :rules="rules" ref="editMarketingForm" data-vv-scope="editMarketingForm">
          <el-row style="height: 4rem">
            <el-col :span="12">
              <el-form-item prop="mapped_name" label="营销项目名称" label-width="200px">
                <el-input
                  class="input-with-select"
                  prefix-icon="el-icon-search"
                  v-model="model.mapped_name"
                  autocomplete="off"
                  ref="inputSelector"
                  clearable
                  placeholder="请选择营销项目"
                  @focus="showMarketingDialog()"
                >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="营销项目编码" label-width="200px">
                <el-input v-model="model.mapped_no" autocomplete="off" placeholder="请输入营销项目编码" readonly="readonly" disabled="disabled"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row style="height: 4rem">
            <el-col :span="12">
              <el-form-item prop="mapping_name_show" label="财务核算项目名称" label-width="200px">
                <el-select v-model="model.mapping_name_show" placeholder="请输入项目名称/编码" clearable filterable @change="setProjectGroups">
                  <el-option v-for="item in selectList" :key="item.id" :label="item.name_show" :value="item.id"> </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="财务核算项目编码" label-width="200px">
                <el-input
                  v-model="model.mapping_no"
                  autocomplete="off"
                  :validate="{ required: true }"
                  placeholder="请输入财务核算项目编码"
                  disabled=""
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row style="height: 4rem">
            <el-col :span="12">
              <el-form-item label="编制人" label-width="200px">
                <el-input v-model="model.create_by_name_" autocomplete="off" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="编制时间" label-width="200px">
                <el-input
                  class="el-input-date"
                  prefix-icon="el-icon-date"
                  v-model="model.createTime"
                  placeholder="选择日期"
                  format="yyyy-MM-dd HH:mm:SS"
                  disabled
                >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitData('editMarketingForm', 'third_financial_mapping/saveMarketProjectMapping')">保存 </el-button>
        <el-button @click="handleClose('editMarketingForm')">{{ $t('eip.common.cancel') }} </el-button>
      </div>
      <evo-marketing-dialog ref="evoMarketingDialog" @onConfirm="addMarketingPro" append-to-body :single="true" />
    </el-dialog>

    <el-dialog
      width="50%"
      append-to-body
      style="height: 800px"
      :title="importTitle"
      class="sp-manager__dialog"
      :visible="importShow"
      :close-on-click-modal="false"
      :before-close="beforeCloseimport"
      @dialogclose="beforeCloseimport"
      :destroy-on-close="true"
    >
      <div slot="title" class="dialog-header-title">
        <span class="name">导入{{ importTitle }}</span>
      </div>
      <eip-import-material
        model-name="importList"
        permission="w"
        propConf='[{"name":"prop1"}]'
        accept="xlsx,xls"
        limit="1"
        displayType="table"
        :multiple="false"
        :importsuccess="true"
        :importurl4="importurl"
        @emitFile="emitFile"
      >
      </eip-import-material>

      <el-row class="import_row">
        <span>模版: </span>
        <span>
          <el-button type="text" @click="downloadTemplate">下载{{ importTitle }}模版</el-button>
        </span>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button element-loading-text="拼命导入中" @click="beforeCloseimport">完 成</el-button>
      </span>
    </el-dialog>

    <!--  行政费用报销科目映射  -->
    <el-dialog :close-on-click-modal="false" width="60%" :visible="showAdministrativeExpenses" :before-close="handleClose" append-to-body>
      <div slot="title" class="dialog-header-title">
        <span class="name">行政费用报销科目映射</span>
      </div>
      <div class="content">
        <el-form :model="model" :rules="rules" ref="editAdministrativeExpensesForm" data-vv-scope="editAdministrativeExpensesForm" label-width="200px">
          <el-row style="height: 4rem">
            <el-col :span="12">
              <el-form-item prop="mapped_name" label="科目名称" label-width="200px">
                <el-select v-model="model.mapped_name" placeholder="请输入费用科目名称" clearable filterable @change="setFykmCode">
                  <el-option v-for="item in fykmDicData" :key="item.key" :label="item.name" :value="item.key"> </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="费用科目编码" label-width="200px">
                <el-input v-model="model.mapped_no" autocomplete="off" placeholder="请输入费用科目编码" disabled></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <span class="name">财务科目映射（子表）</span>
          <ul class="administrative_text_title">
            <li>会计科目名称</li>
            <li>会计科目代码</li>
            <li style="width: 10%">是否默认</li>
            <li style="width: 20%">部门范围</li>
            <li style="width: 10%">操作</li>
          </ul>
          <ul class="administrative_text_title">
            <div v-for="(item, index) in model.sub_expense_subject" :key="index">
              <li>
                <el-select v-model="item.name" placeholder="请输入会计科目名称" clearable filterable @change="setNcOaCode($event, index)">
                  <el-option v-for="item in ncAccountData" :key="item.id" :label="item.name" :value="item.id"> </el-option>
                </el-select>
              </li>
              <li>
                <el-input v-model="item.no" autocomplete="off" placeholder="请输入会计科目代码" disabled></el-input>
              </li>
              <li style="width: 10%">
                <el-select v-model="item.is_default" placeholder="请选择是否默认">
                  <el-option v-for="init in whether" :key="init.id" :label="init.name" :value="init.id"> </el-option>
                </el-select>
              </li>
              <li style="width: 20%">
                <el-input
                  class="input-with-select"
                  v-model="item.dept_name"
                  prefix-icon="el-icon-search"
                  ref="inputSelector"
                  autocomplete="off"
                  placeholder="请选择系统部门"
                  clearable
                  @focus="handleNewdept_name(index)"
                >
                </el-input>
              </li>
              <li style="width: 10%">
                <el-button type="danger" size="small" @click="handleAdministrativeDelete(index)">刪除</el-button>
              </li>
            </div>
          </ul>
          <span @click="handleAddAdministrative" class="add_administrative">+ 添加</span>
        </el-form>
        <div slot="footer" class="admin_button">
          <el-button type="primary" @click="submitData('editAdministrativeExpensesForm', 'third_financial_mapping/saveOaExpenseMapping')">保存 </el-button>
          <el-button @click="handleClose('editGroupForm')">{{ $t('eip.common.cancel') }}</el-button>
        </div>
      </div>
    </el-dialog>
    <!-- 映射类型配置 -->
    <el-dialog v-if="showAcctType" :close-on-click-modal="false" width="50%" :visible="showAcctType" :before-close="handleClose" append-to-body>
      <div slot="title" class="dialog-header-title">
        <span class="name">{{ proType == 'Project' ? '项目组映射配置' : '基础资料组映射配置' }}</span>
      </div>
      <div class="model_type_list" v-if="checkTaxno()">
        <el-form :model="corporate_yy" label-width="200px">
          <el-form-item prop="corporate_name" label="法人机构" label-width="200px" required>
            <el-select v-model="corporate_yy.corporate_name" placeholder="请选择法人机构" clearable filterable @change="(params) => setFRJGCode(params, 3)">
              <el-option v-for="item in frjgDicData" :key="item.company_name" :label="item.company_name" :value="item.company_name"> </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <div class="model_type_list">
        <div class="model_type">
          <p>映射类型</p>
          <div class="model_slot" v-for="item in proType == 'Project' ? newPushArr.slice(0, 3) : newPushArr.slice(3, 4)" :key="item.value">
            {{ item.text }}
          </div>
        </div>
        <div class="model_type" v-if="checkTaxno() && proType != 'Project'">
          <p>部门</p>
          <div class="model_slot" v-for="(item, index) in newPushArr.slice(4, 5)" :key="item.value">
            <el-input
              class="input-with-select"
              v-model="entity[index].emp_mapping_name"
              prefix-icon="el-icon-search"
              ref="inputSelector"
              autocomplete="off"
              placeholder="请选择"
              clearable
              @focus="handleDeptName(index)"
            >
            </el-input>
          </div>
        </div>
        <div class="model_type" v-else>
          <p>财务对应核算项目</p>
          <div class="model_slot" v-for="(item, index) in proType == 'Project' ? newPushArr.slice(0, 3) : newPushArr.slice(3, 7)" :key="item.value">
            <el-select clearable v-model="entity[index]" placeholder="请选择" value-key="id">
              <el-option v-for="pro in projectSelect" :key="pro.id" :label="pro.name + '(' + pro.number + ')'" :value="pro"> </el-option>
            </el-select>
          </div>
        </div>
      </div>
      <div slot="footer" class="admin_button">
        <el-button type="primary" @click="submitProType">保存 </el-button>
      </div>
    </el-dialog>
    <!-- 3.10.0 发票税率映射 -->
    <el-dialog :close-on-click-modal="false" width="60%" :visible="showInvoiceShineuponDialog" :before-close="handleClose" append-to-body v-loading="loadData">
      <div slot="title" class="dialog-header-title">
        <span class="name">发票税率映射</span>
      </div>
      <div class="content">
        <el-form :model="model" :rules="rules" ref="editInvoiceShineupon" data-vv-scope="editInvoiceShineupon">
          <el-row style="height: 4rem">
            <el-col :span="12">
              <el-form-item label="发票税率" label-width="200px">
                <el-select v-model="model.mapped_name" placeholder="请选择发票税率" clearable filterable @change="setFykmCode">
                  <el-option v-for="item in fykmDicData" :key="item.key" :label="item.name" :value="item.key"> </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="付款方式key" label-width="200px">
                <el-input v-model="model.mapped_no" autocomplete="off" :validate="{ required: true }" placeholder="付款方式key" disabled></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row style="height: 4rem">
            <el-col :span="12">
              <el-form-item prop="mapping_name" label="会计科目科目名称" label-width="200px">
                <el-select v-model="model.mapping_name" placeholder="请输入会计科目名称" clearable filterable @change="setNCcode">
                  <el-option v-for="item in ncAccountData" :key="item.id" :label="item.name" :value="item.id"> </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="会计科目代码" label-width="200px">
                <el-input v-model="model.mapping_no" autocomplete="off" placeholder="会计科目代码" disabled="disabled"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item prop="document_mapping_names" label="凭证模版类型" label-width="200px">
                <el-select v-model="model.document_mapping_names" placeholder="凭证模版类型" multiple filterable>
                  <el-option v-for="item in documentEnumData" :key="item.id" :label="item.desc" :value="item.id"> </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row style="height: 4rem">
            <el-col :span="12">
              <el-form-item label="编制人" label-width="200px">
                <el-input v-model="model.create_by_name_" autocomplete="off" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="编制时间" label-width="200px">
                <el-input
                  class="el-input-date"
                  prefix-icon="el-icon-date"
                  v-model="model.createTime"
                  placeholder="选择日期"
                  format="yyyy-MM-dd HH:mm:SS"
                  disabled
                >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitData('editInvoiceShineupon', 'third_financial_mapping/invoiceTaxRateCostAccountMapping')">保存 </el-button>
        <el-button @click="handleClose('editGroupForm')">{{ $t('eip.common.cancel') }}</el-button>
      </div>
    </el-dialog>
    <eip-org-dialog ref="eipOrgDialogs" @onConfirm="addUserOrg" append-to-body :single="true" />
    <!-- 多选 未找到父组件关闭方法，暂定使用两次组件 -->
    <eip-org-dialog ref="newEipOrgDialogs" @onConfirm="addUserOrgArray" append-to-body :single="false" />
    <!--  法人机构账套映射  -->
    <el-dialog :close-on-click-modal="false" width="60%" :visible="dialogVisibleFrjgzt" :before-close="handleClose" append-to-body v-loading="loadData">
      <div slot="title" class="dialog-header-title">
        <span class="name">法人机构账套映射</span>
      </div>
      <div class="content">
        <el-form :model="model" :rules="rules" ref="editFrjgForm" data-vv-scope="editFrjgForm">
          <el-row style="height: 4rem">
            <el-col :span="12">
              <el-form-item prop="mapped_name" label="法人机构" label-width="200px">
                <el-select v-model="model.mapped_name" placeholder="请输入法人机构" clearable filterable @change="(params) => setFRJGCode(params, 1)">
                  <el-option v-for="item in frjgDicData" :key="item.company_name" :label="item.company_name" :value="item.company_name"> </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="账号" label-width="200px">
                <el-input v-model="model.mapped_no" autocomplete="off" placeholder="账号" readonly="readonly" disabled="disabled"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row style="height: 4rem">
            <el-col :span="12">
              <el-form-item prop="mapping_name" label="账套" label-width="200px">
                <el-select v-model="model.mapping_name" placeholder="账套" clearable filterable @change="setFRJGZTCode">
                  <el-option v-for="item in u8AccountList" :key="item.name" :label="item.name" :value="item.name"> </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="账套代码" label-width="200px">
                <el-input v-model="model.mapping_no" autocomplete="off" placeholder="账套代码" disabled="disabled"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row style="height: 4rem">
            <el-col :span="12">
              <el-form-item label="编制人" label-width="200px">
                <el-input v-model="model.create_by_name_" autocomplete="off" :validate="{ required: true }" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="编制时间" label-width="200px">
                <el-input
                  class="el-input-date"
                  prefix-icon="el-icon-date"
                  v-model="model.createTime"
                  placeholder="选择日期"
                  format="yyyy-MM-dd HH:mm:SS"
                  disabled
                >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitData('editFrjgForm', 'third_financial_mapping/saveCorporateMapping')">保存 </el-button>
        <el-button @click="handleClose('editFrjgForm')">{{ $t('eip.common.cancel') }}</el-button>
      </div>
    </el-dialog>
    <eipYongU8Dialog ref="eipYonDialog" :yyId="corporate_yy.corporate_id" @onConfirm="addUserOrg" append-to-body :single="true" />
    <!-- 设计前期项目是否映射科目 -->
    <el-dialog :close-on-click-modal="false" width="60%" :visible="designOnMarketVisible" :before-close="handleClose" append-to-body v-loading="loadData">
      <div slot="title" class="dialog-header-title">
        <span class="name">设计前期项目是否映射科目</span>
      </div>
      <div class="content">
        <el-form :model="designOnMarket" ref="designOnMarketForm" data-vv-scope="designOnMarketForm">
          <el-row style="height: 4rem">
            <eco-form-item label="设计前期项目是否映射科目" label-width="180px">
              <eco-select
                v-model="designOnMarket.isOpen"
                :options="[
                  { key: 1, value: '是' },
                  { key: 0, value: '否' }
                ]"
                :validate="{ required: true }"
              />
            </eco-form-item>
          </el-row>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitParams('designOnMarketForm', 'third_financial_mapping/saveDesignOrMarketConfig')">保存 </el-button>
        <el-button @click="handleClose('designOnMarketForm')">{{ $t('eip.common.cancel') }}</el-button>
      </div>
    </el-dialog>
    <!-- 设计前期项目是否映射科目 -->
    <el-dialog :close-on-click-modal="false" width="60%" :visible="contractTypeVisible" :before-close="handleClose" append-to-body v-loading="loadData">
      <div slot="title" class="dialog-header-title">
        <span class="name">{{ contractTypeTitle + '类型映射' }}</span>
      </div>
      <div class="content">
        <el-form :model="model" :rules="rules" ref="editContractForm" data-vv-scope="editContractForm">
          <el-row style="height: 4rem">
            <el-col :span="12">
              <el-form-item :label="`${contractTypeTitle}合同类型`" label-width="200px">
                <el-select v-model="model.mapped_name" placeholder="请选择合同类型" clearable filterable @change="setFykmCode">
                  <el-option v-for="item in fykmDicData" :key="item.key" :label="item.name" :value="item.key"> </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="合同类型key" label-width="200px">
                <el-input v-model="model.mapped_no" autocomplete="off" :validate="{ required: true }" placeholder="合同类型key" disabled></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row style="height: 4rem">
            <el-col :span="12">
              <el-form-item prop="mapping_name" label="会计科目科目名称" label-width="200px">
                <el-select v-model="model.mapping_name" placeholder="请输入会计科目名称" clearable filterable @change="setNCcode">
                  <el-option v-for="item in ncAccountData" :key="item.id" :label="item.name" :value="item.id"> </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="会计科目代码" label-width="200px">
                <el-input v-model="model.mapping_no" autocomplete="off" placeholder="会计科目代码" disabled="disabled"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row style="height: 4rem">
            <el-col :span="12">
              <el-form-item label="编制人" label-width="200px">
                <el-input v-model="model.create_by_name_" autocomplete="off" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="编制时间" label-width="200px">
                <el-input
                  class="el-input-date"
                  prefix-icon="el-icon-date"
                  v-model="model.createTime"
                  placeholder="选择日期"
                  format="yyyy-MM-dd HH:mm:SS"
                  disabled
                >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitData('editContractForm', `third_financial_mapping/${contractTypeUrl}`)">保存 </el-button>
        <el-button @click="handleClose('editContractForm')">{{ $t('eip.common.cancel') }}</el-button>
      </div>
    </el-dialog>
    <!-- 3.10.0 发票不含税税率映射 -->
    <el-dialog :close-on-click-modal="false" width="60%" :visible="showInvoiceShineDownDialog" :before-close="handleClose" append-to-body v-loading="loadData">
      <div slot="title" class="dialog-header-title">
        <span class="name">发票不含税税率映射</span>
      </div>
      <div class="content">
        <el-form :model="model" :rules="rules" ref="editInvoiceShineDown" data-vv-scope="editInvoiceShineDown">
          <el-row style="height: 4rem">
            <el-col :span="12">
              <el-form-item label="发票税率" label-width="200px">
                <el-select v-model="model.mapped_name" placeholder="请选择发票税率" clearable filterable @change="setFykmCode">
                  <el-option v-for="item in fykmDicData" :key="item.key" :label="item.name" :value="item.key"> </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="付款方式key" label-width="200px">
                <el-input v-model="model.mapped_no" autocomplete="off" :validate="{ required: true }" placeholder="付款方式key" disabled></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row style="height: 4rem">
            <el-col :span="12">
              <el-form-item prop="mapping_name" label="会计科目科目名称" label-width="200px">
                <el-select v-model="model.mapping_name" placeholder="请输入会计科目名称" clearable filterable @change="setNCcode">
                  <el-option v-for="item in ncAccountData" :key="item.id" :label="item.name" :value="item.id"> </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="会计科目代码" label-width="200px">
                <el-input v-model="model.mapping_no" autocomplete="off" placeholder="会计科目代码" disabled="disabled"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item prop="document_mapping_names" label="凭证模版类型" label-width="200px">
                <el-select v-model="model.document_mapping_names" placeholder="凭证模版类型" multiple filterable>
                  <el-option v-for="item in documentEnumData" :key="item.id" :label="item.desc" :value="item.id"> </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row style="height: 4rem">
            <el-col :span="12">
              <el-form-item label="编制人" label-width="200px">
                <el-input v-model="model.create_by_name_" autocomplete="off" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="编制时间" label-width="200px">
                <el-input
                  class="el-input-date"
                  prefix-icon="el-icon-date"
                  v-model="model.createTime"
                  placeholder="选择日期"
                  format="yyyy-MM-dd HH:mm:SS"
                  disabled
                >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitData('editInvoiceShineDown', 'third_financial_mapping/invoiceNoTaxRateCostAccountMapping')">保存 </el-button>
        <el-button @click="handleClose('editInvoiceShineDown')">{{ $t('eip.common.cancel') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import req from '@/request.js'
import portalApi from '@/api/portal.js'
import utils from '@/utils.js'

const eipOrgDialog = () => import('@/components/dialog/EipOrgDialog.vue')
const eipUserDialog = () => import('@/components/dialog/EipUserDialog.vue')
const evoSupplierDialog = () => import('@/components/dialog/EvoSupplierDialog.vue')
const evoCustomerDialog = () => import('@/components/dialog/EvoCustomerDialog.vue')
const evoDesignDialog = () => import('@/components/dialog/ncDialog/EvoDesignProDialog.vue')
const evoProjectDialog = () => import('@/components/dialog/ncDialog/EvoConstructionProDialog.vue')
const evoMarketingDialog = () => import('@/components/dialog/ncDialog/EvoMarketingProDialog.vue')
const eipImportMaterial = () => import('@/components/eipControl/EipImportMaterial.vue')
const eipYongU8Dialog = () => import('@/components/dialog/ncDialog/EipYongU8Dialog.vue')
export default {
  components: {
    eipOrgDialog,
    eipUserDialog,
    evoSupplierDialog,
    evoCustomerDialog,
    evoDesignDialog,
    evoProjectDialog,
    evoMarketingDialog,
    eipYongU8Dialog,
    eipImportMaterial
  },
  computed: {},
  data() {
    return {
      newVal: [],
      entity: [{}],
      documentEnumData: [],
      showAcctType: false,
      requestMethod: 'POST',
      accountUrl: '/third_financial_mapping/saveExpenseMapping',
      showInvoiceShineuponDialog: false,
      showInvoiceShineDownDialog: false,
      dialogVisibleFrjgzt: false,
      designOnMarketVisible: false,
      contractTypeVisible: false,
      dialogVisible: false,
      dialogVisibleBank: false,
      payTypeVisible: false,
      paymentTypeVisible: false,
      invoiceVisible: false,
      dialogVisibleGroup: false,
      dialogVisibleUser: false,
      dialogVisibleSupplier: false,
      dialogVisibleCustomer: false,
      dialogProjectType: false,
      showDesignProject: false,
      showConProject: false,
      showMarketingProject: false,
      showAdministrativeExpenses: false,
      showOaMapping: true,
      showDesignMapping: true,
      showConstructionMapping: true,
      showMarketingMapping: true,
      corporate_yy: {
        corporate_id: '',
        corporate_no: '',
        corporate_name: ''
      },
      designOnMarket: {
        isOpen: 0
      },
      contractTypeTitle: '',
      contractTypeUrl: '',
      model: {
        corporate_id: '',
        mapped_id: '',
        mapped_name: '',
        mapped_no: '',
        pkVal: '',
        mappingList: [],
        //  财务科目映射（子表） 数据体
        sub_expense_subject: [
          {
            name: '',
            no: '',
            id: '',
            is_default: '0',
            dept_name: '',
            dept_id: ''
          }
        ]
      },
      newDeptIndex: null,
      data: [],
      pageResult: {
        page: 1,
        pageSize: 20,
        total: 0
      },
      mappingTypeArray: [
        { text: '营销费用科目', value: '18', type: 'warning' },
        { text: 'OA费用科目', value: '1', type: 'warning' },
        { text: '设计费用科目', value: '2', type: 'warning' },
        { text: '施工费用科目', value: '3', type: 'warning' },
        { text: '银行账号科目', value: '4', type: 'warning' },
        { text: '付款方式科目', value: '5', type: 'warning' },
        { text: '设计费用科目映射(营销)', value: '-5', type: 'warning' },
        { text: '发票', value: '6', type: 'warning' },
        { text: '部门', value: '7', type: 'warning' },
        { text: '职员', value: '8', type: 'warning' },
        { text: '供应商', value: '9', type: 'warning' },
        { text: '客户', value: '10', type: 'warning' },
        { text: '设计项目', value: '12', type: 'warning' },
        { text: '施工项目', value: '14', type: 'warning' },
        { text: '营销项目', value: '16', type: 'warning' },
        { text: '收款方式科目', value: '17', type: 'warning' },
        { text: '发票税率科目', value: '19', type: 'warning' },
        { text: '法人机构账套', value: '20', type: 'warning' },
        { text: '发票不含税税率科目映射', value: '21', type: 'warning' },
        { text: '材料采购合同类型映射', value: '22', type: 'warning' },
        { text: '专业分包合同类型映射', value: '23', type: 'warning' },
        { text: '劳务分包合同类型映射', value: '24', type: 'warning' },
        { text: '租赁合同类型映射', value: '25', type: 'warning' }
      ],
      financialTypeArray: [
        { text: 'k3', value: 'k3', type: 'success' },
        { text: 'kis_ultimate', value: 'kis_ultimate', type: 'success' },
        { text: '用友U8', value: 'yon_u8', type: 'success' }
      ],
      ncAccountData: [],
      fykmDicData: [],
      custpmerList: [],
      supplerList: [],
      orgList: [],
      userList: [],
      bankDicData: [],
      invoiceType: [],
      groupDicData: [],
      projectTypes: [
        { name: '设计项目分组映射', desc: '11', id: '11' },
        { name: '施工项目分组映射', desc: '13', id: '13' },
        { name: '营销项目分组映射', desc: '15', id: '15' }
      ],
      projectGroups: [],
      selectList: [],
      importTitle: '导入',
      importType: '',
      importShow: false,
      importurl: '',
      modelVal: {},
      rules: {
        corporate_id: [{ required: false, message: '必填', trigger: 'change' }],
        mapped_name: [{ required: true, message: '必填', trigger: 'change' }],
        mapped_no: [{ required: true, message: '必填', trigger: 'change' }],
        mapped_name_show: [{ required: true, message: '必填', trigger: 'change' }],
        mapping_name_show: [{ required: true, message: '必填', trigger: 'change' }],
        mapping_name: [{ required: true, message: '必填', trigger: 'change' }]
      },
      whether: [
        {
          name: '是',
          id: '1'
        },
        {
          name: '否',
          id: '0'
        }
      ],
      newEipOrgDialogsIndex: 0,
      tax_no: '',
      projectSelect: [],
      newPushArr: [],
      proType: '',
      tenantId: '',
      frjgDicData: [],
      u8AccountList: []
    }
  },
  created() {
    this.getAccountModuleType()
  },
  mounted() {
    this.$validator = this.$root.$validator
  },
  methods: {
    // 保存操作
    submitProType() {
      if (!this.entity.length) return this.$message.error('请选择配置映射')
      let url = ''
      let arr = {}
      let keyMap = []
      if (this.proType == 'Project') {
        keyMap = [
          {
            id: 'market_mapping_id',
            name: 'market_mapping_name',
            number: 'market_mapping_no'
          },
          {
            id: 'con_mapping_id',
            name: 'con_mapping_name',
            number: 'con_mapping_no'
          },
          {
            id: 'design_mapping_id',
            name: 'design_mapping_name',
            number: 'design_mapping_no'
          }
        ]
        url = '${third}/third_financial_mapping/saveProjectGroupItemMapping'
      } else {
        url = '${third}/third_financial_mapping/saveAccountingItemMapping'
        if (this.checkTaxno()) {
          keyMap = [
            {
              id: 'emp_mapping_id',
              name: 'emp_mapping_name',
              number: 'emp_mapping_no'
            }
          ]
        } else {
          keyMap = [
            {
              id: 'dept_mapping_id',
              name: 'dept_mapping_name',
              number: 'dept_mapping_no'
            },
            {
              id: 'emp_mapping_id',
              name: 'emp_mapping_name',
              number: 'emp_mapping_no'
            },
            {
              id: 'supplier_mapping_id',
              name: 'supplier_mapping_name',
              number: 'supplier_mapping_no'
            },
            {
              id: 'customer_mapping_id',
              name: 'customer_mapping_name',
              number: 'customer_mapping_no'
            }
          ]
        }
      }
      this.entity.forEach((item, index) => {
        let obj = this.entity[index]
        for (let key in obj) {
          this.$set(arr, keyMap[index][key], this.entity[index][key])
        }
      })
      arr.create_by_name_ = sessionStorage.getItem('tenantName')
      this.$http.post(url, arr).then((res) => {
        if (res && res.data.state) {
          this.$message.success('操作成功')
          this.showAcctType = false
          this.entity = []
          this.loadData()
        }
      })
    },
    // 映射类型配置dialog
    showAcctTypeDialog(type) {
      this.proType = type
      if (!this.checkTaxno()) {
        this.getTypeDetail()
        this.getProjectGroup()
      }
      this.showAcctType = true
    },
    getTypeDetail() {
      let url = ''
      let keyMap = []
      if (this.proType == 'Project') {
        url = '${third}/third_financial_mapping/getProjectGroupItemMapping'
        keyMap = [
          {
            id: 'market_mapping_id',
            name: 'market_mapping_name',
            number: 'market_mapping_no'
          },
          {
            id: 'con_mapping_id',
            name: 'con_mapping_name',
            number: 'con_mapping_no'
          },
          {
            id: 'design_mapping_id',
            name: 'design_mapping_name',
            number: 'design_mapping_no'
          }
        ]
      } else {
        url = '${third}/third_financial_mapping/getAccountingItemMapping'
        // 判断是否是U8
        if (this.checkTaxno()) {
          keyMap = [
            {
              id: 'emp_mapping_id',
              name: 'emp_mapping_name',
              number: 'emp_mapping_no'
            }
          ]
        } else {
          keyMap = [
            {
              id: 'market_mapping_id',
              name: 'market_mapping_name',
              number: 'market_mapping_no'
            },
            {
              id: 'con_mapping_id',
              name: 'con_mapping_name',
              number: 'con_mapping_no'
            },
            {
              id: 'design_mapping_id',
              name: 'design_mapping_name',
              number: 'design_mapping_no'
            },
            {
              id: 'customer_mapping_id',
              name: 'customer_mapping_name',
              number: 'customer_mapping_no'
            }
          ]
        }
      }
      this.$http
        .get(url, 'json', {
          corporateId: this.corporate_yy.corporate_id
        })
        .then((res) => {
          if (res && res.data) {
            this.entity = keyMap
            this.entity.forEach((item, index) => {
              let obj = this.entity[index]
              for (let key in obj) {
                this.$set(this.entity[index], key, res.data[keyMap[index][key]])
              }
            })
          }
        })
    },
    /**
     * 判断是否是U8
     * @param name
     * @returns {boolean}
     */
    checkTaxno(name = 'yon_u8') {
      return this.tax_no === name
    },
    // 查询下拉接口
    getProjectGroup() {
      this.$http.get('${third}/project_group/getById?id=0&parentId=0').then((res) => {
        if (res && res.data) {
          this.projectSelect = res.data
        }
      })
    },
    // 通过模块控制映射按钮权限
    getAccountModuleType() {
      let tenantId = typeof sessionStorage.getItem('tenantId') == 'undefined' ? sessionStorage.getItem('tenantId') : sessionStorage.getItem('currentTenantId')
      this.tenantId = tenantId
      if (tenantId) {
        this.$http.get('${third}/system/account_mangement/getByTenantIdAndModule?id=' + `${tenantId}&accountModule=6`).then((res) => {
          if (res && res.data) {
            this.tax_no = res.data.tax_no
            let arr = []
            if (this.tax_no == 'kis_ultimate' || this.checkTaxno()) {
              arr = [
                { text: '营销项目分组映射', value: '15', type: 'warning' },
                { text: '施工项目分组映射', value: '13', type: 'warning' },
                { text: '设计项目分组映射', value: '11', type: 'warning' },
                { text: '部门组映射', value: '-1', type: 'warning' },
                { text: '职员组映射', value: '-2', type: 'warning' },
                { text: '供应商组映射', value: '-3', type: 'warning' },
                { text: '客户组映射', value: '-4', type: 'warning' }
              ]
              this.mappingTypeArray.push(...arr)
              this.newPushArr = arr
              if (this.checkTaxno()) {
                this.getCorporateInfo()
                this.rules.corporate_id = [{ required: true, message: '必填', trigger: 'change' }]
              }
            }
          }
        })
      }
    },
    submitData(formName, url) {
      if (formName === 'editAdministrativeExpensesForm') {
        if (
          this.model.sub_expense_subject.every((item) => {
            return item.is_default === '0'
          })
        ) {
          return this.$message.info('需要配置一个默认映射')
        }
        if (
          this.model.sub_expense_subject.some((item) => {
            return item.no === ''
          })
        ) {
          return this.$message.info('需要选择一个会计科目')
        }
      }
      if (formName === 'editInvoiceShineupon') {
        if (this.model.document_mapping_names && this.model.document_mapping_names.length) {
          this.model.document_mapping_ids = this.model.document_mapping_names.map((i) => i).join(',')
          this.model.document_mapping_names = ''
        }
      }
      if (formName === 'editInvoiceShineDown') {
        if (this.model.document_mapping_names && this.model.document_mapping_names.length) {
          this.model.document_mapping_ids = this.model.document_mapping_names.map((i) => i).join(',')
          this.model.document_mapping_names = ''
        }
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let param = this.model
          this.$http.post('${third}/' + url, param).then((res) => {
            this.afterSaveData()
          })
        } else {
          this.$message.warning('请正确填写表单内容！')
          return false
        }
      })
    },
    submitParams(formName, url) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let param = this.designOnMarket
          this.$http.get('${third}/' + url + '?isOpen=' + param.isOpen).then((res) => {
            this.afterSaveData()
          })
        } else {
          this.$message.warning('请正确填写表单内容！')
          return false
        }
      })
    },
    submiteditModelFormData(formName, url, requestMethod) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let param = this.model
          if (requestMethod == 'POST') {
            this.$http.post('${third}' + url, param).then((res) => {
              this.afterSaveData()
            })
          }
          if (requestMethod == 'PUT') {
            this.$http.put('${third}' + url, param).then((res) => {
              this.afterSaveData()
            })
          }
        } else {
          this.$message.warning('请正确填写表单内容！')
          return false
        }
      })
    },
    handleClose() {
      this.paymentTypeVisible = false
      this.dialogVisible = false
      this.dialogVisibleBank = false
      this.payTypeVisible = false
      this.invoiceVisible = false
      this.dialogVisibleGroup = false
      this.dialogVisibleUser = false
      this.dialogVisibleSupplier = false
      this.dialogVisibleCustomer = false
      this.dialogProjectType = false
      this.showDesignProject = false
      this.showConProject = false
      this.showMarketingProject = false
      this.showAdministrativeExpenses = false
      this.dialogVisibleFrjgzt = false
      this.designOnMarketVisible = false
      this.contractTypeVisible = false
      this.showAcctType = false
      this.model = {}
      this.afterSaveData()
      this.model = {
        corporate_id: '',
        mapped_id: '',
        mapped_name: '',
        mapped_no: '',
        pkVal: '',
        mappingList: [],
        //  财务科目映射（子表） 数据体
        sub_expense_subject: [
          {
            name: '',
            no: '',
            id: '',
            is_default: '0',
            dept_name: '',
            dept_id: ''
          }
        ]
      }
      this.corporate_yy = {
        corporate_id: '',
        corporate_no: '',
        corporate_name: ''
      }
      this.entity = []
    },
    ShowExpenseAccount() {
      this.dialogVisible = true
      this.getDic('fykm')
      this.getNcAccount()
      this.showOaMapping = false
      this.showDesignMapping = true
      this.showConstructionMapping = true
      this.showMarketingMapping = true
      this.model = {
        create_by: this.$store.state.user.currentUserDetail.user.userId,
        create_by_name_: this.$store.state.user.currentUserDetail.user.fullname,
        createTime: utils.formatDate(new Date())
      }
    },
    showDialog(row) {
      if (row) {
        this.requestMethod = 'PUT'
        this.accountUrl = '/third_financial_mapping/'
        let object = JSON.parse(JSON.stringify(row))
        this.model = object
        switch (row.mapping_type) {
          case '1':
            this.showAdministrativeExpenses = true
            this.$http.get('${third}' + `/third_financial_mapping/getOaByKey/${row.mapped_no}`).then((res) => {
              this.model = res.data
            })
            break
          case '2':
            this.dialogVisible = true
            this.model.design_mapping_name = row.mapping_name
            this.model.design_mapping_no = row.mapping_no
            this.model.design_mapping_id = row.mapping_id
            this.showDesignMapping = true
            this.showOaMapping = false
            this.showConstructionMapping = false
            this.showMarketingMapping = false
            break
          case '3':
            this.dialogVisible = true
            this.model.construction_mapping_name = row.mapping_name
            this.model.construction_mapping_no = row.mapping_no
            this.model.construction_mapping_id = row.mapping_id
            this.showDesignMapping = false
            this.showOaMapping = false
            this.showConstructionMapping = true
            this.showMarketingMapping = false
            break
          case '18':
            this.dialogVisible = true
            this.model.market_mapping_name = row.mapping_name
            this.model.market_mapping_no = row.mapping_no
            this.model.market_mapping_id = row.mapping_id
            this.showDesignMapping = false
            this.showOaMapping = false
            this.showConstructionMapping = false
            this.showMarketingMapping = true
            break
          default:
            break
        }
        setTimeout(() => {
          this.$validator.validateAll('editModelForm')
        })
      } else {
        this.requestMethod = 'POST'
        this.accountUrl = '/third_financial_mapping/saveExpenseMapping'
        this.model = {
          create_by: this.$store.state.user.currentUserDetail.user.userId,
          create_by_name_: this.$store.state.user.currentUserDetail.user.fullname,
          createTime: utils.formatDate(new Date())
        }
        this.showDesignMapping = true
        this.showOaMapping = true
        this.showConstructionMapping = true
      }
      this.getDic('fykm')
      this.getNcAccount()
    },
    showDialogBank(row) {
      this.dialogVisibleBank = true
      this.getNcAccount()
      if (row) {
        let object = JSON.parse(JSON.stringify(row))
        this.model = object
        this.model.oa_mapping_name = object.mapping_name
        setTimeout(() => {
          this.$validator.validateAll('editBankForm')
        })
      } else {
        this.model = {
          oa_mapping_name: '',
          create_by: this.$store.state.user.currentUserDetail.user.userId,
          create_by_name_: this.$store.state.user.currentUserDetail.user.fullname,
          createTime: utils.formatDate(new Date())
        }
      }
      this.getBank()
    },
    showPayType(row) {
      this.payTypeVisible = true
      this.model = {}
      this.getNcAccount()
      this.getDic('termsofpayment')
      if (row) {
        let object = JSON.parse(JSON.stringify(row))
        this.model = object
        setTimeout(() => {
          this.$validator.validateAll('editPayTypeForm')
        })
      } else {
        this.model = {
          create_by: this.$store.state.user.currentUserDetail.user.userId,
          create_by_name_: this.$store.state.user.currentUserDetail.user.fullname,
          createTime: utils.formatDate(new Date())
        }
      }
    },
    showPayMentType(row) {
      this.paymentTypeVisible = true
      this.model = {}
      this.getNcAccount()
      this.getDic('cwskfs')
      if (row) {
        let object = JSON.parse(JSON.stringify(row))
        this.model = object
        setTimeout(() => {
          this.$validator.validateAll('editPayMentTypeForm')
        })
      } else {
        this.model = {
          create_by: this.$store.state.user.currentUserDetail.user.userId,
          create_by_name_: this.$store.state.user.currentUserDetail.user.fullname,
          createTime: utils.formatDate(new Date())
        }
      }
    },
    showInvoiceType(row) {
      this.invoiceVisible = true
      if (row) {
        this.getOldInvoiceType(row)
        setTimeout(() => {
          this.$validator.validateAll('editInvoiceForm')
        })
      } else {
        this.model = {
          create_by: this.$store.state.user.currentUserDetail.user.userId,
          create_by_name_: this.$store.state.user.currentUserDetail.user.fullname,
          createTime: utils.formatDate(new Date()),
          mappingList: []
        }
        this.getInvoiceType()
      }
    },
    showGroup(row) {
      this.dialogVisibleGroup = true
      this.getOrgList()
      this.model = {}
      if (row) {
        let object = JSON.parse(JSON.stringify(row))
        this.model = object
        this.model.mapped_name_show = this.model.mapping_name + '(' + this.model.mapping_no + ')'
        setTimeout(() => {
          this.$validator.validateAll('editGroupForm')
        })
      } else {
        this.model = {
          mapped_name_show: '',
          create_by: this.$store.state.user.currentUserDetail.user.userId,
          create_by_name_: this.$store.state.user.currentUserDetail.user.fullname,
          createTime: utils.formatDate(new Date())
        }
      }
    },
    showUser(row) {
      this.dialogVisibleUser = true
      this.getUserList()
      this.model = {}
      if (row) {
        let object = JSON.parse(JSON.stringify(row))
        this.model = object
        this.model.mapped_name_show = this.model.mapping_name + '(' + this.model.mapping_no + ')'
        setTimeout(() => {
          this.$validator.validateAll('editUserForm')
        })
      } else {
        this.model = {
          mapped_name_show: '',
          create_by: this.$store.state.user.currentUserDetail.user.userId,
          create_by_name_: this.$store.state.user.currentUserDetail.user.fullname,
          createTime: utils.formatDate(new Date())
        }
      }
    },
    showSupplier(row) {
      this.dialogVisibleSupplier = true
      this.getSupplerList()
      this.model = {}
      if (row) {
        let object = JSON.parse(JSON.stringify(row))
        this.model = object
        this.model.mapped_name_show = this.model.mapping_name + '(' + this.model.mapping_no + ')'
        setTimeout(() => {
          this.$validator.validateAll('editSupplierForm')
        })
      } else {
        this.model = {
          mapped_name_show: '',
          create_by: this.$store.state.user.currentUserDetail.user.userId,
          create_by_name_: this.$store.state.user.currentUserDetail.user.fullname,
          createTime: utils.formatDate(new Date())
        }
      }
    },
    showCustomer(row) {
      this.dialogVisibleCustomer = true
      this.getCustomerList()
      this.model = {}
      if (row) {
        let object = JSON.parse(JSON.stringify(row))
        this.model = object
        this.model.mapped_name_show = this.model.mapping_name + '(' + this.model.mapping_no + ')'
        setTimeout(() => {
          this.$validator.validateAll('editCustomerForm')
        })
      } else {
        this.model = {
          mapped_name_show: '',
          create_by: this.$store.state.user.currentUserDetail.user.userId,
          create_by_name_: this.$store.state.user.currentUserDetail.user.fullname,
          createTime: utils.formatDate(new Date())
        }
      }
    },
    showProjectType(row) {
      this.dialogProjectType = true
      this.getProjectType()
      this.model = {}
      if (row) {
        let object = JSON.parse(JSON.stringify(row))
        this.model = object
        this.model.mapped_name_show = this.model.mapped_name + '(' + this.model.mapped_no + ')'
        this.model.mapping_name_show = this.model.mapping_name + '(' + this.model.mapping_no + ')'
        setTimeout(() => {
          this.$validator.validateAll('editProjectTypeForm')
        })
      } else {
        this.model = {
          mapped_name_show: '',
          create_by: this.$store.state.user.currentUserDetail.user.userId,
          create_by_name_: this.$store.state.user.currentUserDetail.user.fullname,
          createTime: utils.formatDate(new Date())
        }
      }
    },
    showProjectDesign(row) {
      this.selectList = []
      this.showDesignProject = true
      this.getProject('2')
      this.model = {}
      if (row) {
        let object = JSON.parse(JSON.stringify(row))
        this.model = object
        this.model.mapped_name_show = this.model.mapping_name + '(' + this.model.mapping_no + ')'
        setTimeout(() => {
          this.$validator.validateAll('editDesignProjectForm')
        })
      } else {
        this.model = {
          mapped_name_show: '',
          create_by: this.$store.state.user.currentUserDetail.user.userId,
          create_by_name_: this.$store.state.user.currentUserDetail.user.fullname,
          createTime: utils.formatDate(new Date())
        }
      }
    },
    showProject(row) {
      this.selectList = []
      this.showConProject = true
      this.getProject('3')
      this.model = {}
      if (row) {
        let object = JSON.parse(JSON.stringify(row))
        this.model = object
        this.model.mapped_name_show = this.model.mapping_name + '(' + this.model.mapping_no + ')'
        setTimeout(() => {
          this.$validator.validateAll('editConProjectForm')
        })
      } else {
        this.model = {
          mapped_name_show: '',
          create_by: this.$store.state.user.currentUserDetail.user.userId,
          create_by_name_: this.$store.state.user.currentUserDetail.user.fullname,
          createTime: utils.formatDate(new Date())
        }
      }
    },
    showProjectMarketing(row) {
      this.selectList = []
      this.showMarketingProject = true
      this.getProject('1')
      this.model = {}
      if (row) {
        let object = JSON.parse(JSON.stringify(row))
        this.model = object
        this.model.mapping_name_show = this.model.mapping_name + '(' + this.model.mapping_no + ')'
        setTimeout(() => {
          this.$validator.validateAll('editMarketingForm')
        })
      } else {
        this.model = {
          mapping_name_show: '',
          create_by: this.$store.state.user.currentUserDetail.user.userId,
          create_by_name_: this.$store.state.user.currentUserDetail.user.fullname,
          createTime: utils.formatDate(new Date())
        }
      }
    },
    loadData(param, cb) {
      if (!param) {
        param = {
          pageBean: this.pageResult
        }
      }
      portalApi
        .getSysNcConfig(param)
        .then((response) => {
          this.data = response.rows
          this.pageResult = {
            page: response.page,
            pageSize: response.pageSize,
            total: response.total
          }
        })
        .finally(() => cb())
    },
    handleCommand(params) {
      switch (params.command) {
        case 'edit':
          switch (params.row.mapping_type) {
            case '1':
              this.showDialog(params.row)
              break
            case '2':
              this.showDialog(params.row)
              break
            case '3':
              this.showDialog(params.row)
              break
            case '4':
              this.showDialogBank(params.row)
              break
            case '5':
              this.showPayType(params.row)
              break
            case '6':
              this.showInvoiceType(params.row)
              break
            case '7':
              this.showGroup(params.row)
              break
            case '8':
              this.showUser(params.row)
              break
            case '9':
              this.showSupplier(params.row)
              break
            case '10':
              this.showCustomer(params.row)
              break
            case '11':
              this.showProjectType(params.row)
              break
            case '12':
              this.showProjectDesign(params.row)
              break
            case '13':
              this.showProjectType(params.row)
              break
            case '14':
              this.showProject(params.row)
              break
            case '15':
              this.showProjectType(params.row)
              break
            case '16':
              this.showProjectMarketing(params.row)
              break
            case '17':
              this.showPayMentType(params.row)
              break
            case '18':
              this.showDialog(params.row)
              break
            case '19':
              this.showInvoiceShineupon(params.row)
              break
            case '20':
              this.showFrjgztDialog(params.row)
              break
            case '21':
              this.showInvoiceShineDown(params.row)
              break
            case '22':
              this.showContract(params.row, params.row.mapping_type)
              break
            case '23':
              this.showContract(params.row, params.row.mapping_type)
              break
            case '24':
              this.showContract(params.row, params.row.mapping_type)
              break
            case '25':
              this.showContract(params.row, params.row.mapping_type)
              break
          }
          break
        case 'save':
          break
        default:
          break
      }
    },
    afterSaveData() {
      this.paymentTypeVisible = false
      this.dialogVisible = false
      this.dialogVisibleBank = false
      this.payTypeVisible = false
      this.invoiceVisible = false
      this.dialogVisibleGroup = false
      this.dialogVisibleUser = false
      this.dialogVisibleSupplier = false
      this.dialogVisibleCustomer = false
      this.dialogProjectType = false
      this.showDesignProject = false
      this.showConProject = false
      this.showMarketingProject = false
      this.showAdministrativeExpenses = false
      this.showInvoiceShineuponDialog = false
      this.showInvoiceShineDownDialog = false
      this.designOnMarketVisible = false
      this.contractTypeVisible = false
      this.model = {}
      this.$refs.ecoTable.load()
    },
    showImport(type, costAccountType) {
      switch (type) {
        case 'CostAccount':
          this.importType = type
          switch (costAccountType) {
            case 1:
              this.importTitle = 'OA费用科目'
              break
            case 2:
              this.importTitle = '设计费用科目'
              break
            case 3:
              this.importTitle = '施工费用科目'
              break
            case 18:
              this.importTitle = '营销费用科目'
              break
            case -5:
              this.importTitle = '设计项目(营销)'
              break
          }
          this.importurl = window.context.third + '/third_financial_mapping/importCostAccountXlsx/' + costAccountType
          break
        case 'Org':
          this.importType = type
          this.importTitle = '部门关系'
          this.importurl = window.context.third + '/third_financial_mapping/importOrgXlsx'
          break
        case 'User':
          this.importType = type
          this.importTitle = '员工关系'
          this.importurl = window.context.third + '/third_financial_mapping/importUserXlsx'
          break
        case 'Supplier':
          this.importType = type
          this.importTitle = '供应商关系'
          this.importurl = window.context.third + '/third_financial_mapping/importSupplierXlsx'
          break
        case 'Customer':
          this.importType = type
          this.importTitle = '客户关系'
          this.importurl = window.context.third + '/third_financial_mapping/importCustomerXlsx'
          break
        case 'DesignPro':
          this.importType = type
          this.importTitle = '设计项目'
          this.importurl = window.context.third + '/third_financial_mapping/importDesignProXlsx'
          break
        case 'ConPro':
          this.importType = type
          this.importTitle = '施工项目'
          this.importurl = window.context.third + '/third_financial_mapping/importConProXlsx'
          break
        case 'MarketPro':
          this.importType = type
          this.importTitle = '营销项目'
          this.importurl = window.context.third + '/third_financial_mapping/importMarketProXlsx'
          break
        default:
          this.importType = ''
          this.importTitle = ''
          this.importurl = ''
          break
      }
      this.importShow = true
    },
    beforeCloseimport() {
      this.loadData()
      this.importShow = false
    },
    downloadTemplate() {
      switch (this.importType) {
        case 'CostAccount':
          req.download('${third}/third_financial_mapping/exportModelCostAccount')
          break
        case 'Org':
          req.download('${third}/third_financial_mapping/exportModelOrg')
          break
        case 'User':
          req.download('${third}/third_financial_mapping/exportModelUser')
          break
        case 'Supplier':
          req.download('${third}/third_financial_mapping/exportModelSupplier')
          break
        case 'Customer':
          req.download('${third}/third_financial_mapping/exportModelCustomer')
          break
        case 'DesignPro':
          req.download('${third}/third_financial_mapping/exportModelDesignPro')
          break
        case 'ConPro':
          req.download('${third}/third_financial_mapping/exportModelConPro')
          break
        case 'MarketPro':
          req.download('${third}/third_financial_mapping/exportModelMarketPro')
          break
        default:
          break
      }
    },
    emitFile(value) {
      // console.info(value);
      if (value && value.file && value.file.response && !value.file.response.result) {
        this.$confirm('导入存在错误，是否下载错误信息?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            switch (this.importType) {
              case 'CostAccount':
                req.post('${third}/third_financial_mapping/exportFormErrorCostAccount', value.file.response, null, 'arraybuffer')
                break
              case 'Org':
                req.post('${third}/third_financial_mapping/exportFormErrorOrg', value.file.response, null, 'arraybuffer')
                break
              case 'User':
                req.post('${third}/third_financial_mapping/exportFormErrorUser', value.file.response, null, 'arraybuffer')
                break
              case 'Supplier':
                req.post('${third}/third_financial_mapping/exportFormErrorSupplier', value.file.response, null, 'arraybuffer')
                break
              case 'Customer':
                req.post('${third}/third_financial_mapping/exportFormErrorCustomer', value.file.response, null, 'arraybuffer')
                break
              case 'DesignPro':
                req.post('${third}/third_financial_mapping/exportFormErrorDesignPro', value.file.response, null, 'arraybuffer')
                break
              case 'ConPro':
                req.post('${third}/third_financial_mapping/exportFormErrorConPro', value.file.response, null, 'arraybuffer')
                break
              case 'MarketPro':
                req.post('${third}/third_financial_mapping/exportFormErrorMarketPro', value.file.response, null, 'arraybuffer')
                break
              default:
                break
            }
          })
          .catch(() => {})
      }
    },
    getDic(key) {
      this.fykmDicData = []
      portalApi.getByTypeKey(key).then((response) => {
        this.fykmDicData = response
      })
    },
    getInvoiceType(key) {
      // 进项发票开票类型
      if (!key) {
        key = 'jxfpkplx'
      }
      portalApi.getByTypeKey(key).then((response) => {
        response.forEach((item) => {
          item.is_deductible = 0
          item.mapped_name = item.name
          item.mapped_no = item.key
        })
        this.model.mappingList = response
      })
    },
    getOldInvoiceType(model) {
      this.model = {
        create_by: model.createBy,
        create_by_name_: model.create_by_name_,
        createTime: utils.formatDate(model.createTime),
        mappingList: []
      }
      this.$http.get('${third}/third_financial_mapping/getInvoiceList').then((response) => {
        if (response.data) {
          let list = response.data
          this.model.mappingList = list
          this.model.mappingList.forEach((item) => {
            if (item.is_deductible) {
              item.is_deductible = '1'
            } else {
              item.is_deductible = '0'
            }
          })
        }
      })
    },
    getBank() {
      this.bankDicData = []
      if (true) {
        this.$http
          .post('${portal}/system/tenant_bank_info/query', {
            pageBean: { page: 1, pageSize: 500, total: 1 }
          })
          .then(
            (resp) => {
              let response = resp.data
              let res = response.rows
              res.forEach((item) => {
                this.bankDicData.push({
                  id: item.id,
                  key: item.bank_account,
                  name: item.deposit_bank + '(' + item.bank_account + ')'
                })
              })
            },
            (error) => {
              reject(error)
            }
          )
          .finally(() => {})
      }
    },
    getProjectType() {
      if (true) {
        this.$http.get('${third}/third_financial_mapping/getEnumProjectTypeMap').then((response) => {
          if (response.data) {
            this.projectTypes = response.data
            this.projectTypes.forEach((item) => {
              item.name_show = item.desc + '(' + item.name + ')'
            })
          }
        })
        this.$http.get('${third}/project_group/getById?id=0&parentId=0').then((datas) => {
          if (datas.data) {
            this.projectGroups = datas.data
            this.projectGroups.forEach((item) => {
              item.name_show = item.name + '(' + item.number + ')'
            })
          }
        })
      }
    },
    getProject(key) {
      this.selectList = []
      this.$http.get('${third}/project/getById?id=0&parentId=0&type=' + key).then((response) => {
        if (response.data) {
          this.selectList = response.data
          this.selectList.forEach((item) => {
            item.name_show = item.name + '(' + item.number + ')'
          })
        }
      })
    },
    getNcAccount() {
      this.ncAccountData = []
      portalApi.getCostAccountById().then((response) => {
        this.ncAccountData = response
        this.ncAccountData.forEach((item) => {
          item.name_show = item.name
        })
      })
    },
    getCustomerList() {
      this.custpmerList = []
      this.$http.get('${third}/customer/getById?id=0&parentId=0').then((datas) => {
        if (datas.data) {
          this.custpmerList = datas.data
          this.custpmerList.forEach((customer) => {
            customer.name_show = customer.name + '(' + customer.number + ')'
          })
        }
      })
    },
    getSupplerList() {
      this.supplerList = []
      this.$http.get('${third}/supplier/getById?id=0&parentId=0').then((datas) => {
        if (datas.data) {
          this.supplerList = datas.data
          this.supplerList.forEach((supplier) => {
            supplier.name_show = supplier.name + '(' + supplier.number + ')'
          })
        }
      })
    },
    getUserList() {
      this.userList = []
      this.$http.get('${third}/user/getById?id=0').then((datas) => {
        if (datas.data) {
          this.userList = datas.data
          this.userList.forEach((item) => {
            item.name_show = item.name + '(' + item.number + ')'
          })
        }
      })
    },
    getOrgList() {
      this.orgList = []
      this.$http.get('${third}/org/getById?id=0').then((datas) => {
        if (datas.data) {
          this.orgList = datas.data
          this.orgList.forEach((item) => {
            item.name_show = item.name + '(' + item.number + ')'
          })
        }
      })
    },
    setFykmCode(key) {
      let selectObj = ''
      this.fykmDicData.forEach((item) => {
        if (item.key == key) {
          selectObj = item
        }
      })
      if (selectObj) {
        this.model.mapped_name = selectObj.name
        this.model.mapped_no = key
        this.model.mapped_id = key
      } else {
        this.model.mapped_name = ''
        this.model.mapped_no = ''
        this.model.mapped_id = ''
      }
    },
    setNcOaCode(key, index) {
      let selectObj = ''
      this.ncAccountData.forEach((item) => {
        if (item.id == key) {
          selectObj = item
        }
      })
      if (selectObj) {
        this.model.oa_mapping_name = selectObj.name
        this.model.oa_mapping_no = selectObj.number
        this.model.oa_mapping_id = selectObj.id
        this.model.mapping_name = selectObj.name
        this.model.mapping_no = selectObj.number
        this.model.mapping_id = selectObj.id
        this.model.sub_expense_subject[index].name = selectObj.name
        this.model.sub_expense_subject[index].no = selectObj.number
        this.model.sub_expense_subject[index].id = selectObj.id
      } else {
        this.model.oa_mapping_name = ''
        this.model.oa_mapping_no = ''
        this.model.oa_mapping_id = ''
        this.model.sub_expense_subject[index].name = ''
        this.model.sub_expense_subject[index].no = ''
        this.model.sub_expense_subject[index].id = ''
      }
    },
    setNcDesignCode(key) {
      let selectObj = ''
      this.ncAccountData.forEach((item) => {
        if (item.id == key) {
          selectObj = item
        }
      })
      if (selectObj) {
        this.model.design_mapping_name = selectObj.name
        this.model.design_mapping_no = selectObj.number
        this.model.design_mapping_id = selectObj.id
        this.model.mapping_name = selectObj.name
        this.model.mapping_no = selectObj.number
        this.model.mapping_id = selectObj.id
      } else {
        this.model.design_mapping_name = ''
        this.model.design_mapping_no = ''
        this.model.design_mapping_id = ''
      }
    },
    setNcConstructionCode(key) {
      let selectObj = ''
      this.ncAccountData.forEach((item) => {
        if (item.id == key) {
          selectObj = item
        }
      })
      if (selectObj) {
        this.model.construction_mapping_name = selectObj.name
        this.model.construction_mapping_no = selectObj.number
        this.model.construction_mapping_id = selectObj.id
        this.model.mapping_name = selectObj.name
        this.model.mapping_no = selectObj.number
        this.model.mapping_id = selectObj.id
      } else {
        this.model.construction_mapping_name = ''
        this.model.construction_mapping_no = ''
        this.model.construction_mapping_id = ''
      }
    },
    setNcMarketingCode(key) {
      let selectObj = ''
      this.ncAccountData.forEach((item) => {
        if (item.id == key) {
          selectObj = item
        }
      })
      if (selectObj) {
        this.model.market_mapping_name = selectObj.name
        this.model.market_mapping_no = selectObj.number
        this.model.market_mapping_id = selectObj.id
        this.model.mapping_name = selectObj.name
        this.model.mapping_no = selectObj.number
        this.model.mapping_id = selectObj.id
      } else {
        this.model.market_mapping_name = ''
        this.model.market_mapping_no = ''
        this.model.market_mapping_id = ''
      }
    },
    setBankCode(key) {
      let item = ''
      this.bankDicData.forEach((selectObj) => {
        if (selectObj.key == key) {
          item = selectObj
        }
      })
      if (item) {
        this.model.mapped_id = item.id
        this.model.mapped_no = item.key
        this.model.mapped_name = item.name
      } else {
        this.model.mapped_id = ''
        this.model.mapped_no = ''
        this.model.mapped_name = ''
      }
    },
    setFRJGCode(key, flag) {
      let item = this.frjgDicData.find((selectObj) => selectObj.company_name == key)
      switch (flag) {
        case 1:
          if (item) {
            this.model.mapped_id = item.id
            this.model.mapped_no = item.bank_no
            this.model.mapped_name = item.company_name
          } else {
            this.model.mapped_id = ''
            this.model.mapped_no = ''
            this.model.mapped_name = ''
          }
          break
        case 2:
          if (item) {
            this.model.corporate_id = item.id
            this.model.corporate_no = item.bank_no
            this.model.corporate_name = item.company_name
          } else {
            this.model.corporate_id = ''
            this.model.corporate_no = ''
            this.model.corporate_name = ''
          }
          break
        case 3:
          if (item) {
            this.corporate_yy.corporate_id = item.id
            this.corporate_yy.corporate_no = item.bank_no
            this.corporate_yy.corporate_name = item.company_name
            this.getTypeDetail()
            this.getProjectGroup()
          } else {
            this.corporate_yy.corporate_id = ''
            this.corporate_yy.corporate_no = ''
            this.corporate_yy.corporate_name = ''
          }
          break
      }
    },
    setFRJGZTCode(key) {
      let item = ''
      this.u8AccountList.forEach((selectObj) => {
        if (selectObj.name == key) {
          item = selectObj
        }
      })
      if (item) {
        this.model.mapping_id = item.sequence
        this.model.mapping_no = item.U8.sys_id
        this.model.mapping_name = item.name
      } else {
        this.model.mapping_name = ''
        this.model.mapping_id = ''
        this.model.mapping_no = ''
      }
    },
    setNCcode(key) {
      let item = {}
      this.ncAccountData.forEach((value) => {
        if (value.id == key) {
          item = value
        }
      })
      if (item) {
        this.model.mapping_name = item.name
        this.model.mapping_id = item.id
        this.model.mapping_no = item.number
      } else {
        this.model.mapping_name = ''
        this.model.mapping_id = ''
        this.model.mapping_no = ''
      }
    },

    setDeptCode(key) {
      let item = {}
      this.orgList.forEach((value) => {
        if (value.id == key) {
          item = value
        }
      })
      if (item) {
        this.model.mapping_name = item.name
        this.model.mapping_id = item.id
        this.model.mapping_no = item.number
      } else {
        this.model.mapping_name = ''
        this.model.mapping_id = ''
        this.model.mapping_no = ''
      }
    },
    setUserCode(key) {
      let item = {}
      this.userList.forEach((value) => {
        if (value.id == key) {
          item = value
        }
      })
      if (item) {
        this.model.mapping_name = item.name
        this.model.mapping_id = item.id
        this.model.mapping_no = item.number
      } else {
        this.model.mapping_name = ''
        this.model.mapping_id = ''
        this.model.mapping_no = ''
      }
    },
    setSupplerCode(key) {
      let item = {}
      this.supplerList.forEach((value) => {
        if (value.id == key) {
          item = value
        }
      })
      if (item) {
        this.model.mapping_name = item.name
        this.model.mapping_id = item.id
        this.model.mapping_no = item.number
      } else {
        this.model.mapping_name = ''
        this.model.mapping_id = ''
        this.model.mapping_no = ''
      }
    },
    setProjectType(key) {
      let item = {}
      this.projectTypes.forEach((value) => {
        if (value.name == key) {
          item = value
        }
      })
      if (item) {
        this.model.mapped_name = item.desc
        this.model.mapped_id = item.id
        this.model.mapped_no = item.name
      } else {
        this.model.mapped_name = ''
        this.model.mapped_id = ''
        this.model.mapped_no = ''
      }
    },
    setProjectGroupTypes(key) {
      let item = {}
      this.projectGroups.forEach((value) => {
        if (value.id == key) {
          item = value
        }
      })
      if (item) {
        this.model.mapping_name = item.name
        this.model.mapping_id = item.id
        this.model.mapping_no = item.number
      } else {
        this.model.mapping_name = ''
        this.model.mapping_id = ''
        this.model.mapping_no = ''
      }
    },
    setProjectGroups(val) {
      let item = this.getVel(val)
      if (item) {
        this.model.mapping_name = item.name
        this.model.mapping_id = item.id
        this.model.mapping_no = item.number
      } else {
        this.model.mapping_name = ''
        this.model.mapping_id = ''
        this.model.mapping_no = ''
      }
    },
    getVel(val) {
      let returnVal = ''
      this.selectList.forEach((item) => {
        if (item.id == val) {
          returnVal = item
        }
      })
      return returnVal
    },
    setCustomerCode(val) {
      let item = ''
      this.custpmerList.forEach((value) => {
        if (value.id == val) {
          item = value
        }
      })
      if (item) {
        this.model.mapping_name = item.name
        this.model.mapping_id = item.id
        this.model.mapping_no = item.number
      } else {
        this.model.mapping_name = ''
        this.model.mapping_id = ''
        this.model.mapping_no = ''
      }
    },
    addUnderUser(newVal) {
      if (newVal) {
        this.model.mapped_no = newVal[0].userNumber
        this.model.mapped_id = newVal[0].id
        this.$set(this.model, 'mapped_name', newVal[0].fullname)
      }
    },
    addUserOrg(newVal) {
      if (newVal) {
        if (this.newDeptIndex !== null) {
          this.$set(this.entity[this.newDeptIndex], 'emp_mapping_id', newVal[0].id)
          this.$set(this.entity[this.newDeptIndex], 'emp_mapping_name', newVal[0].name)
          this.$set(this.entity[this.newDeptIndex], 'emp_mapping_no', newVal[0].code)
        } else {
          this.model.mapped_no = newVal[0].code
          this.model.mapped_id = newVal[0].id
          this.$set(this.model, 'mapped_name', newVal[0].name)
        }
        this.newDeptIndex = null
      }
    },
    addUserOrgArray(newVal) {
      if (newVal) {
        this.model.sub_expense_subject[this.newEipOrgDialogsIndex].dept_name = newVal.map((item) => item.name).join(',')
        this.model.sub_expense_subject[this.newEipOrgDialogsIndex].dept_id = newVal.map((item) => item.id).join(',')
      }
    },
    addSupplier(newVal) {
      if (newVal) {
        this.model.mapped_no = newVal[0].customer_id
        this.model.mapped_id = newVal[0].id
        this.$set(this.model, 'mapped_name', newVal[0].customer_name)
      }
    },
    addDesignPro(newVal) {
      if (newVal) {
        this.model.mapped_no = newVal[0].design_maketing_pro_no
        this.model.mapped_id = newVal[0].id
        this.$set(this.model, 'mapped_name', newVal[0].design_maketing_pro_name)
      }
    },
    addConstructionPro(newVal) {
      if (newVal) {
        this.model.mapped_no = newVal[0].construction_pro_no
        this.model.mapped_id = newVal[0].id
        this.$set(this.model, 'mapped_name', newVal[0].construction_pro_name)
      }
    },
    addMarketingPro(newVal) {
      if (newVal) {
        this.model.mapped_no = newVal[0].marketing_pro_no
        this.model.mapped_id = newVal[0].id
        this.$set(this.model, 'mapped_name', newVal[0].marketing_pro_name)
      }
    },
    showUserDialog() {
      this.$refs.inputSelector.blur()
      this.$refs.eipUserDialog.showDialog()
    },
    showOrgDialog() {
      this.$refs.inputSelector.blur()
      this.$refs.eipOrgDialogs.showDialog()
    },
    showSupplierDialog() {
      this.$refs.inputSelector.blur()
      this.$refs.evoSupplierDialog.showDialog()
    },
    showCustomerDialog() {
      this.$refs.inputSelector.blur()
      this.$refs.evoCustomerDialog.showDialog()
    },
    showConstructionProDialog() {
      this.$refs.inputSelector.blur()
      this.$refs.evoProjectDialog.showDialog()
    },
    showDesignDialog() {
      this.$refs.inputSelector.blur()
      this.$refs.evoDesignDialog.showDialog()
    },
    showMarketingDialog() {
      this.$refs.inputSelector.blur()
      this.$refs.evoMarketingDialog.showDialog()
    },
    setPayMentCode(key) {
      let selectObj = ''
      this.ncAccountData.forEach((item) => {
        if (item.id == key) {
          selectObj = item
        }
      })
      if (selectObj) {
        this.model.mapping_name = selectObj.name
        this.model.mapping_no = selectObj.number
        this.model.mapping_id = selectObj.id
      } else {
        this.model.mapping_name = ''
        this.model.mapping_no = ''
        this.model.mapping_id = ''
      }
    },
    setCwskfsCode(key) {
      let selectObj = ''
      this.fykmDicData.forEach((item) => {
        if (key == item.key) {
          selectObj = item
        }
      })
      if (selectObj) {
        this.model.mapped_name = selectObj.name
        this.model.mapped_no = key
      } else {
        this.model.mapped_name = ''
        this.model.mapped_no = ''
      }
    },
    handleNewdept_name(index) {
      this.newEipOrgDialogsIndex = index
      if (this.model.sub_expense_subject[index].dept_id) {
        this.$refs.newEipOrgDialogs.showDialog(
          this.saveNewArr(this.model.sub_expense_subject[index].dept_name.split(','), this.model.sub_expense_subject[index].dept_id.split(','))
        )
      } else {
        this.$refs.newEipOrgDialogs.showDialog()
      }
    },
    // 判断是否需要
    checkIfNeedFrjg() {
      if (this.checkTaxno() && !this.corporate_yy.corporate_id) {
        this.$message.error('请先选择法人机构')
        return false
      }
    },
    handleDeptName(index) {
      this.checkIfNeedFrjg()
      this.newDeptIndex = index
      this.$refs.eipYonDialog.showDialog()
    },
    saveNewArr(key = [], value = []) {
      const arr = []
      key.map((v, i) => {
        const obj = {}
        obj['name'] = key[i]
        obj['id'] = value[i]
        arr.push(obj)
      })
      return arr
    },
    handleAdministrativeDelete(index) {
      this.model.sub_expense_subject.splice(index, 1)
    },
    showAdministrative() {
      this.showAdministrativeExpenses = true
      this.getDic('fykm')
      this.getNcAccount()
    },
    showInvoiceShineupon(row) {
      this.getNcAccount()
      this.getDic('zzssl')
      if (row) {
        let object = JSON.parse(JSON.stringify(row))
        this.model = object
        if (this.model.document_mapping_ids != '') {
          this.model.document_mapping_names = this.model.document_mapping_ids.split(',')
        }
        setTimeout(() => {
          this.$validator.validateAll('editInvoiceShineupon')
        })
      } else {
        this.model = {
          create_by: this.$store.state.user.currentUserDetail.user.userId,
          create_by_name_: this.$store.state.user.currentUserDetail.user.fullname,
          createTime: utils.formatDate(new Date())
        }
      }
      req.get('${third}/third_document_template/getDocumentEnumMap').then((response) => {
        this.documentEnumData = response.data
      })
      this.showInvoiceShineuponDialog = true
    },
    showInvoiceShineDown(row) {
      this.getNcAccount()
      this.getDic('zzssl')
      if (row) {
        let object = JSON.parse(JSON.stringify(row))
        this.model = object
        if (this.model.document_mapping_ids != '') {
          this.model.document_mapping_names = this.model.document_mapping_ids.split(',')
        }
        setTimeout(() => {
          this.$validator.validateAll('editInvoiceShineupon')
        })
      } else {
        this.model = {
          create_by: this.$store.state.user.currentUserDetail.user.userId,
          create_by_name_: this.$store.state.user.currentUserDetail.user.fullname,
          createTime: utils.formatDate(new Date())
        }
      }
      req.get('${third}/third_document_template/getDocumentEnumMap').then((response) => {
        this.documentEnumData = response.data
      })
      this.showInvoiceShineDownDialog = true
    },
    getCorporateInfo() {
      this.$http.post('${portal}/system/tenant_corporate_info/query?tenantId=' + this.tenantId).then((resp) => {
        let response = resp.data
        this.frjgDicData = response.rows
      })
    },
    getU8AccountList() {
      this.$http.post('${third}/u8/data_source/getList').then((resp) => {
        this.u8AccountList = resp.data.map((i) => {
          return {
            name: `${i.sequence}——${i.U8.sys_id}`,
            ...i
          }
        })
      })
    },
    showFrjgztDialog(row) {
      this.getU8AccountList()
      if (row) {
        this.model = JSON.parse(JSON.stringify(row))
        setTimeout(() => {
          this.$validator.validateAll('editFrjgForm')
        })
      } else {
        this.model = {
          create_by: this.$store.state.user.currentUserDetail.user.userId,
          create_by_name_: this.$store.state.user.currentUserDetail.user.fullname,
          createTime: utils.formatDate(new Date())
        }
      }
      this.dialogVisibleFrjgzt = true
    },
    handleAddAdministrative() {
      this.model.sub_expense_subject.push({
        name: '',
        no: '',
        id: '',
        is_default: '0',
        dept_name: '',
        dept_id: ''
      })
    },
    showParamsSet() {
      this.$http.get('${third}/third_financial_mapping/getDesignOrMarketConfig?tenantId=' + this.tenantId + '&isOpen=0').then((resp) => {
        this.designOnMarket.isOpen = resp.data
        this.designOnMarketVisible = true
      })
    },
    showContract(row, flag) {
      this.fykmDicData = []
      this.getNcAccount()
      switch (flag) {
        case '22':
          this.getDic('clcghtlx')
          this.contractTypeUrl = 'saveCostContractTypeClMapping'
          this.contractTypeTitle = '材料采购合同'
          break
        case '23':
          this.getDic('zyfbhtlx')
          this.contractTypeUrl = 'saveCostContractTypeZyMapping'
          this.contractTypeTitle = '专业分包合同'
          break
        case '24':
          this.getDic('lwfbhtlx')
          this.contractTypeUrl = 'saveCostContractTypeLwMapping'
          this.contractTypeTitle = '劳务分包合同'
          break
        case '25':
          this.getDic('zlhtlx')
          this.contractTypeUrl = 'saveCostContractTypeZlMapping'
          this.contractTypeTitle = '租赁合同'
          break
      }
      if (row) {
        this.model = JSON.parse(JSON.stringify(row))
        setTimeout(() => {
          this.$validator.validateAll('editContractForm')
        })
      } else {
        this.model = {
          create_by: this.$store.state.user.currentUserDetail.user.userId,
          create_by_name_: this.$store.state.user.currentUserDetail.user.fullname,
          createTime: utils.formatDate(new Date())
        }
      }
      this.contractTypeVisible = true
    }
  }
}
</script>
<style scoped>
div[aria-invalid='true'] >>> .el-input__inner,
div[aria-invalid='true'] >>> .el-input__inner:focus {
  border-color: #f56c6c;
}

.input-with-select {
}

.el-input-date {
}

/deep/ .el-input--small {
  font-size: 13px;
}

/deep/ .el-select--small {
  width: 100%;
}

/deep/ .el-pagination__editor.el-input {
  width: 50px;
}

/deep/ .quick-search > div {
  font-size: 13px;
}

>>> .import_row {
  margin-top: 15px;
  margin-bottom: 15px;
}

.toolbarItem {
  margin-left: 10px;
}

.administrative_text_title {
  width: 100%;
  list-style: none;
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  padding: 0;
}
.administrative_text_title div {
  width: 100%;
  display: flex;
  justify-content: space-around;
}
.administrative_text_title li {
  width: 15%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 20px;
  margin-bottom: 10px;
}
.add_administrative {
  color: #2d8cf0;
  cursor: pointer;
}
.admin_button {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 30px;
}
.model_type_list {
  display: flex;
}
.model_type {
  flex: 1;
}
.model_type p {
  text-align: center;
}
.model_slot {
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
